var _path, _path2, _polygon, _polygon2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHealthI(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-13"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--floor--inject-13",
    cx: 250,
    cy: 355.57,
    rx: 228.65,
    ry: 136.85,
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--Shadow--inject-13",
    d: "M355.23,371.39,265.7,319.7a8.58,8.58,0,0,0-7.74,0h0l-96.29,55.77-20.31,11.74c-2.14,1.24-2.14,3.24,0,4.47l89.35,51.59a8.56,8.56,0,0,0,7.73,0l116.79-67.41C357.36,374.63,357.36,372.63,355.23,371.39Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-13",
    cx: 332.58,
    cy: 426.57,
    rx: 63.8,
    ry: 36.83,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-13",
    cx: 415.16,
    cy: 417.79,
    rx: 63.8,
    ry: 36.83,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-13",
    cx: 90.3,
    cy: 418.99,
    rx: 71.32,
    ry: 41.18,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-13",
    d: "M182.41,253.34l-172,99.42a1.35,1.35,0,0,0,0,2.55l49.21,28.4a4.91,4.91,0,0,0,4.42,0l172-99.42a1.35,1.35,0,0,0,0-2.55l-49.21-28.4A4.89,4.89,0,0,0,182.41,253.34Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-13",
    d: "M316.71,253.34l172,99.42a1.35,1.35,0,0,1,0,2.55l-49.21,28.4a4.91,4.91,0,0,1-4.42,0l-172-99.42a1.35,1.35,0,0,1,0-2.55l49.21-28.4A4.89,4.89,0,0,1,316.71,253.34Z",
    style: {
      fill: "#f0f0f0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Window--inject-13"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-13"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-13"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Frame--inject-13"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "471.17 192.37 469.04 193.64 396.69 151.87 398.82 150.6 471.17 192.37",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "398.82 150.6 469.04 191.14 469.04 68.74 398.82 28.22 398.82 150.6",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.68,154.19l80.37,46.4V66.43L392.68,20Zm4-127.22L469,68.74v124.9l-72.35-41.77Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "396.69 151.87 398.82 150.6 398.82 28.22 396.69 26.97 396.69 151.87",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "469.04 162.12 469.04 164.62 396.69 122.85 398.82 121.58 469.04 162.12",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "469.04 90.65 469.04 93.14 396.69 51.37 398.82 50.1 469.04 90.65",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "392.68 20.02 394.84 18.79 475.21 65.19 473.05 66.42 392.68 20.02",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "475.21 65.19 473.05 66.42 473.05 200.59 475.21 199.35 475.21 65.19",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "438.1 50.88 435.94 49.63 435.94 174.54 438.1 173.3 438.1 50.88",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "431.92 47.32 435.94 49.63 435.94 174.54 431.92 172.21 431.92 47.32",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "392.68 49.06 392.68 53.69 473.05 100.09 473.05 95.46 392.68 49.06",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "392.68 120.53 392.68 125.15 473.05 171.56 473.05 166.93 392.68 120.53",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "435.94 74.03 438.1 72.78 469.04 90.65 469.04 93.14 435.94 74.03",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "435.94 145.48 438.1 144.23 469.04 162.1 469.04 164.59 435.94 145.48",
    style: {
      fill: "#fafafa"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Diplomas--inject-13"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Diploma--inject-13"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-13"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "368.28 122.8 366.82 123.64 330.32 102.57 331.79 101.73 368.28 122.8",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "331.79 101.73 366.82 121.96 366.82 91.59 331.79 71.36 331.79 101.73",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.86,103.41l39.42,22.76V90.75L328.87,68Zm1.47-32.89,36.49,21.07v32.05l-36.49-21.07Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "330.32 102.57 331.79 101.73 331.79 71.36 330.32 70.52 330.32 102.57",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "328.87 67.99 330.32 67.15 369.74 89.91 368.28 90.75 328.87 67.99",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "369.74 89.91 368.28 90.75 368.28 126.17 369.74 125.33 369.74 89.91",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M358.24,108a5.46,5.46,0,0,1,2.46,4.27c0,1.57-1.1,2.21-2.46,1.42a5.43,5.43,0,0,1-2.47-4.26C355.77,107.85,356.88,107.22,358.24,108Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.57,90.21,340,79.49c-.52-.3-.94-.06-.94.54v0A2.08,2.08,0,0,0,340,81.7l18.56,10.73c.51.3.93.06.93-.54v-.06A2.08,2.08,0,0,0,358.57,90.21Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.5,98.65l-24.41-14.1c-.52-.3-.94-.16-.94.31a1.88,1.88,0,0,0,.94,1.38l24.43,14.11c.52.29.93.16.93-.31A1.92,1.92,0,0,0,361.5,98.65Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.5,102l-24.41-14.1c-.52-.3-.94-.16-.94.3a1.88,1.88,0,0,0,.94,1.39l24.43,14.1c.52.3.93.16.93-.3A1.92,1.92,0,0,0,361.5,102Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.5,105.39l-24.41-14.1c-.52-.3-.94-.16-.94.3a1.84,1.84,0,0,0,.94,1.38l24.43,14.11c.52.3.93.16.93-.31A1.9,1.9,0,0,0,361.5,105.39Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.86,110.15a2.66,2.66,0,0,1-.61-.54,1.7,1.7,0,0,1-.46-1.43c0-.16-.23-.68-.35-.6a8.92,8.92,0,0,1-1.05.44c-.21.1-.61.41-1.11-.28a1.45,1.45,0,0,1-.28-.87,1.22,1.22,0,0,0,.33-1.15c0-.17-.29-.68-.37-.56a2,2,0,0,0-.32,1,1.82,1.82,0,0,1-.79.27,2.11,2.11,0,0,1-.5.1c-.05,0-.14,0-.21,0a.55.55,0,0,1-.18-.39.76.76,0,0,1,.09-.41h0s0,0,0,0h0c0-.17-.21-.66-.3-.55a1.51,1.51,0,0,1-1.43.73l-.09,0c0-.1,0-.23,0-.33a4.32,4.32,0,0,0-.12-.8c0-.15-.22-.53-.32-.5-.52.15-.93.56-1.63.37a2.75,2.75,0,0,1-.34-.16c-.11-.19.06-.59.09-.65a2.66,2.66,0,0,1,.24-.51,1,1,0,0,0,.19-.42c0-.16-.31-.87-.38-.67s-.12.24-.22.45a3.25,3.25,0,0,1-1.37.73,2.13,2.13,0,0,1-1.91-.36,2.48,2.48,0,0,1-.86-.88,2.19,2.19,0,0,1-.22-.95,3.43,3.43,0,0,1,.23-1.42,7.4,7.4,0,0,0,2.11,1,2.21,2.21,0,0,0,1.61.07c.21-.14.34-.63-.18-1.46A3.15,3.15,0,0,0,342,98.24a3.06,3.06,0,0,0-1.16-.44,1.42,1.42,0,0,0-1.45,1,2.93,2.93,0,0,0-.17.38,11.53,11.53,0,0,1-2.69-2.65c-.05-.07-.07,0,0,.09a12.85,12.85,0,0,0,2.63,2.79,3.64,3.64,0,0,0,.59,3.31,2.62,2.62,0,0,0,2.6,1.4,2.26,2.26,0,0,0,1-.47.11.11,0,0,1,.08,0A1.72,1.72,0,0,0,344,105a1,1,0,0,0,1.16.23,5.69,5.69,0,0,0,.69-.25,2.2,2.2,0,0,0,.52,1.44c.4.37.75.07.94,0a1.8,1.8,0,0,0,.46-.23,2.44,2.44,0,0,0,.1.24c.33.76.74.83.95.8a4.56,4.56,0,0,0,1-.2,3.14,3.14,0,0,0,.4.92c.52.85,1,1,1.31,1a2.15,2.15,0,0,0,1-.45,3.09,3.09,0,0,0,.36.92,3.7,3.7,0,0,0,1.23,1.34C354.18,110.79,354,110.26,353.86,110.15ZM342.43,99c.24.15.75.53.77,1,0,.25-.2.3-.33.33a3,3,0,0,1-1.42-.13,7.19,7.19,0,0,1-1.78-.7C340.12,98.47,341,98.05,342.43,99Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--diploma--inject-13"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-13"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "137.69 74.44 139.15 75.28 175.64 54.21 174.18 53.37 137.69 74.44",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "174.18 53.37 139.15 73.59 139.15 43.23 174.18 23 174.18 53.37",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.1,19.63,137.69,42.38V77.81L177.1,55.05Zm-1.46,34.58L139.15,75.28V43.23l36.49-21.07Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "175.64 54.21 174.18 53.37 174.18 23 175.64 22.16 175.64 54.21",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "177.1 19.63 175.64 18.79 136.23 41.54 137.69 42.38 177.1 19.63",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "136.23 41.54 137.69 42.38 137.69 77.81 136.23 76.97 136.23 41.54",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M167.31,48.26c1.36-.78,2.46-.15,2.46,1.42A5.43,5.43,0,0,1,167.31,54c-1.36.79-2.46.15-2.46-1.42A5.46,5.46,0,0,1,167.31,48.26Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.4,41.85,166,31.12c.52-.29.93-.05.93.54v.06a2.07,2.07,0,0,1-.93,1.62L147.4,44.07c-.52.29-.94,0-.94-.54v-.07A2,2,0,0,1,147.4,41.85Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.46,50.29l24.42-14.1c.52-.3.93-.16.93.3a1.83,1.83,0,0,1-.93,1.38L144.44,52c-.51.3-.93.16-.92-.31A1.9,1.9,0,0,1,144.46,50.29Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.46,53.65l24.42-14.09c.52-.3.93-.17.93.3a1.85,1.85,0,0,1-.93,1.38L144.44,55.35c-.51.3-.93.16-.92-.31A1.9,1.9,0,0,1,144.46,53.65Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.46,57l24.42-14.1c.52-.29.93-.16.93.31a1.86,1.86,0,0,1-.93,1.38L144.44,58.72c-.51.3-.93.16-.92-.31A1.9,1.9,0,0,1,144.46,57Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.93,55.47a1.32,1.32,0,0,1-.61.16c-.53,0-.48-.53-.46-.9,0-.16-.22-.42-.35-.2-.31.57-.71,1.1-1,1.66-.21.34-.61,1.11-1.11,1-.21,0-.28-.27-.28-.55a2.69,2.69,0,0,0,.33-1.52c0-.16-.29-.36-.37-.14a4.83,4.83,0,0,0-.32,1.4,8.25,8.25,0,0,1-.79,1.17c-.17.23-.32.48-.5.69,0,0-.13.18-.21.19s-.15-.07-.17-.18a1.22,1.22,0,0,1,.08-.5h0s0,0,0,0h0c0-.17-.21-.41-.3-.21a7.35,7.35,0,0,1-1.43,2.39l-.09.08c0-.1,0-.2,0-.29a2.2,2.2,0,0,0-.12-.67c0-.1-.22-.27-.32-.12a11.56,11.56,0,0,1-1.63,2.24,1.81,1.81,0,0,1-.34.24c-.11-.06.06-.66.09-.75a7.75,7.75,0,0,1,.24-.78,2.86,2.86,0,0,0,.19-.65c0-.2-.31-.51-.37-.24,0,.11-.13.38-.23.71A16.83,16.83,0,0,1,151.4,62a5.19,5.19,0,0,1-1.91,1.84c-.21.12-.62.29-.86.12a1,1,0,0,1-.22-.7,5.74,5.74,0,0,1,.23-1.69,10.16,10.16,0,0,0,2.12-1.49,7.49,7.49,0,0,0,1.6-1.77c.21-.39.34-1-.18-1.26s-.84.1-1.14.27a4.91,4.91,0,0,0-1.17.91,6.6,6.6,0,0,0-1.45,2.66c0,.15-.11.35-.17.58a4.59,4.59,0,0,1-2.69.45c-.05,0-.07.1,0,.12a4.4,4.4,0,0,0,2.63-.26c-.23,1-.37,2.38.59,2.64s2.09-.93,2.6-1.61a11.14,11.14,0,0,0,1-1.65l.08-.12c0,.47.1.82.56.74s.9-.75,1.16-1.11.46-.7.69-1c0,.43.12.91.53.83s.74-.79.93-1.08a6.68,6.68,0,0,0,.46-.76l.1.14c.33.36.74,0,.95-.32a14.4,14.4,0,0,0,1-1.29.77.77,0,0,0,.4.45c.52.25,1-.18,1.31-.57a11.06,11.06,0,0,0,1-1.58.72.72,0,0,0,.35.5,1.21,1.21,0,0,0,1.23-.08C163.25,55.73,163.1,55.38,162.93,55.47Zm-11.43,2c.24-.12.75-.33.77.08a1.3,1.3,0,0,1-.33.71,8.47,8.47,0,0,1-1.42,1.51,11.5,11.5,0,0,1-1.78,1.36A5.74,5.74,0,0,1,151.5,57.51Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--diploma--inject-13"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-13"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "137.69 122.81 139.15 123.66 175.64 102.59 174.18 101.74 137.69 122.81",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "174.18 101.74 139.15 121.97 139.15 91.61 174.18 71.38 174.18 101.74",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.1,68,137.69,90.76v35.43l39.41-22.76Zm-1.46,34.58-36.49,21.07v-32l36.49-21.07Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "175.64 102.59 174.18 101.74 174.18 71.38 175.64 70.53 175.64 102.59",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "177.1 68.01 175.64 67.16 136.23 89.92 137.69 90.76 177.1 68.01",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "136.23 89.92 137.69 90.76 137.69 126.19 136.23 125.34 136.23 89.92",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M167.31,96.64c1.36-.79,2.46-.15,2.46,1.42a5.46,5.46,0,0,1-2.46,4.27c-1.36.78-2.46.15-2.46-1.42A5.44,5.44,0,0,1,167.31,96.64Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.4,90.22,166,79.5c.52-.3.93,0,.93.54v.06a2,2,0,0,1-.93,1.61L147.4,92.44c-.52.3-.94.06-.94-.54v-.06A2.08,2.08,0,0,1,147.4,90.22Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.46,98.66l24.42-14.09c.52-.3.93-.17.93.3a1.85,1.85,0,0,1-.93,1.38l-24.44,14.11c-.51.3-.93.16-.92-.31A1.9,1.9,0,0,1,144.46,98.66Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.46,102l24.42-14.1c.52-.29.93-.16.93.31a1.86,1.86,0,0,1-.93,1.38l-24.44,14.11c-.51.3-.93.16-.92-.31A1.9,1.9,0,0,1,144.46,102Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.46,105.4l24.42-14.1c.52-.3.93-.16.93.31a1.86,1.86,0,0,1-.93,1.38L144.44,107.1c-.51.29-.93.16-.92-.31A1.9,1.9,0,0,1,144.46,105.4Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.93,103.85a1.46,1.46,0,0,1-.61.16c-.53,0-.48-.53-.46-.9,0-.17-.22-.42-.35-.2-.31.57-.71,1.1-1,1.66-.21.34-.61,1.1-1.11,1-.21,0-.28-.26-.28-.54a2.71,2.71,0,0,0,.33-1.53c0-.16-.29-.35-.37-.13a4.75,4.75,0,0,0-.32,1.4,8.87,8.87,0,0,1-.79,1.17c-.17.23-.32.48-.5.69,0,0-.13.18-.21.19s-.15-.07-.17-.19a1.28,1.28,0,0,1,.08-.5h0s0,0,0,0h0c0-.17-.21-.41-.3-.21a7.35,7.35,0,0,1-1.43,2.39l-.09.08c0-.1,0-.2,0-.29a2.2,2.2,0,0,0-.12-.67c0-.1-.22-.27-.32-.13a11.33,11.33,0,0,1-1.63,2.25,3.73,3.73,0,0,1-.34.24c-.11-.07.06-.66.09-.75a7.75,7.75,0,0,1,.24-.78,2.86,2.86,0,0,0,.19-.65c0-.2-.31-.51-.37-.24,0,.11-.13.38-.23.71a17.44,17.44,0,0,1-1.37,2.32,5.27,5.27,0,0,1-1.91,1.84c-.21.12-.62.29-.86.11s-.21-.47-.22-.69a5.74,5.74,0,0,1,.23-1.69,10.16,10.16,0,0,0,2.12-1.49,7.54,7.54,0,0,0,1.6-1.78c.21-.39.34-1-.18-1.25s-.84.1-1.14.27a5.14,5.14,0,0,0-1.17.9,6.7,6.7,0,0,0-1.45,2.67c0,.15-.11.35-.17.58a4.59,4.59,0,0,1-2.69.45c-.05,0-.07.1,0,.11a4.32,4.32,0,0,0,2.63-.25c-.23,1-.37,2.37.59,2.64s2.09-.93,2.6-1.62a10.55,10.55,0,0,0,1-1.64.5.5,0,0,1,.08-.12c0,.47.1.81.56.74s.9-.75,1.16-1.11.46-.7.69-1c0,.42.12.91.53.83s.74-.79.93-1.08a6.68,6.68,0,0,0,.46-.76.64.64,0,0,0,.1.13c.33.37.74,0,.95-.31s.67-.84,1-1.3a.76.76,0,0,0,.4.46c.52.25,1-.19,1.31-.57a11.65,11.65,0,0,0,1-1.58.75.75,0,0,0,.35.5,1.21,1.21,0,0,0,1.23-.08C163.25,104.11,163.1,103.76,162.93,103.85Zm-11.43,2c.24-.13.75-.33.77.08a1.33,1.33,0,0,1-.33.71,8.83,8.83,0,0,1-1.42,1.51,12.16,12.16,0,0,1-1.78,1.36A5.74,5.74,0,0,1,151.5,105.89Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--diploma--inject-13"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-13"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "368.28 74.44 366.82 75.28 330.32 54.21 331.79 53.37 368.28 74.44",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "331.79 53.37 366.82 73.59 366.82 43.23 331.79 23 331.79 53.37",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.86,55.05l39.42,22.76V42.38L328.87,19.63Zm1.47-32.89,36.49,21.07V75.28L330.33,54.21Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "330.32 54.21 331.79 53.37 331.79 23 330.32 22.16 330.32 54.21",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "328.87 19.63 330.32 18.79 369.74 41.54 368.28 42.38 328.87 19.63",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "369.74 41.54 368.28 42.38 368.28 77.81 369.74 76.97 369.74 41.54",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M358.24,59.64a5.46,5.46,0,0,1,2.46,4.27c0,1.57-1.1,2.21-2.46,1.42a5.47,5.47,0,0,1-2.47-4.27C355.77,59.49,356.88,58.85,358.24,59.64Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.57,41.85,340,31.12c-.52-.29-.94-.05-.94.54v.06a2.09,2.09,0,0,0,.93,1.62l18.56,10.73c.51.29.93,0,.93-.54v-.07A2.06,2.06,0,0,0,358.57,41.85Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.5,50.29l-24.41-14.1c-.52-.3-.94-.16-.94.3a1.84,1.84,0,0,0,.94,1.38L361.52,52c.52.3.93.16.93-.31A1.92,1.92,0,0,0,361.5,50.29Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.5,53.65,337.09,39.56c-.52-.3-.94-.17-.94.3a1.86,1.86,0,0,0,.94,1.38l24.43,14.11c.52.3.93.16.93-.31A1.92,1.92,0,0,0,361.5,53.65Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.5,57l-24.41-14.1c-.52-.29-.94-.16-.94.31a1.88,1.88,0,0,0,.94,1.38l24.43,14.11c.52.3.93.16.93-.31A1.92,1.92,0,0,0,361.5,57Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.86,61.79a2.73,2.73,0,0,1-.61-.55,1.69,1.69,0,0,1-.46-1.42c0-.16-.23-.68-.35-.6a8.88,8.88,0,0,1-1.05.43c-.21.1-.61.41-1.11-.28a1.4,1.4,0,0,1-.28-.86,1.23,1.23,0,0,0,.33-1.15c0-.18-.29-.68-.37-.57a2.08,2.08,0,0,0-.32,1,1.68,1.68,0,0,1-.79.26,2.78,2.78,0,0,1-.5.11c-.05,0-.14,0-.21-.05a.53.53,0,0,1-.18-.39.72.72,0,0,1,.09-.4h0s0,0,0,0v0c0-.16-.21-.65-.3-.54a1.53,1.53,0,0,1-1.43.73l-.09,0c0-.11,0-.23,0-.34a4.11,4.11,0,0,0-.12-.79c0-.16-.22-.54-.32-.51-.52.15-.93.56-1.63.37a1.34,1.34,0,0,1-.34-.16c-.11-.19.06-.58.09-.64a2.66,2.66,0,0,1,.24-.51,1.09,1.09,0,0,0,.19-.42c0-.16-.31-.87-.38-.67s-.12.23-.22.44a3.39,3.39,0,0,1-1.37.74,2.13,2.13,0,0,1-1.91-.36,2.57,2.57,0,0,1-.86-.88,2.19,2.19,0,0,1-.22-1,3.51,3.51,0,0,1,.23-1.43,6.88,6.88,0,0,0,2.11,1,2.27,2.27,0,0,0,1.61.08c.21-.14.34-.64-.18-1.47a3.2,3.2,0,0,0-1.15-1,3.06,3.06,0,0,0-1.16-.44,1.42,1.42,0,0,0-1.45,1,4,4,0,0,0-.17.39,11.53,11.53,0,0,1-2.69-2.65c-.05-.07-.07,0,0,.09A12.85,12.85,0,0,0,339.1,51a3.62,3.62,0,0,0,.59,3.3c1,1.45,2.09,1.5,2.6,1.4a2.15,2.15,0,0,0,1-.46.11.11,0,0,1,.08,0,1.72,1.72,0,0,0,.56,1.38,1,1,0,0,0,1.16.23,5.69,5.69,0,0,0,.69-.25,2.16,2.16,0,0,0,.52,1.43c.4.38.75.07.94,0a1.8,1.8,0,0,0,.46-.23l.1.24c.33.76.74.83.95.8a4.56,4.56,0,0,0,1-.2,3.38,3.38,0,0,0,.4.92c.52.85,1,1,1.31.94a2.14,2.14,0,0,0,1-.44,3,3,0,0,0,.36.91A3.62,3.62,0,0,0,354,62.34C354.18,62.43,354,61.9,353.86,61.79ZM342.43,50.63c.24.16.75.54.77,1,0,.25-.2.29-.33.33a3,3,0,0,1-1.42-.13,7.19,7.19,0,0,1-1.78-.7C340.12,50.11,341,49.69,342.43,50.63Z",
    style: {
      fill: "#e0e0e0"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Negatoscope--inject-13"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--negatoscope--inject-13"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-13"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "30.26 176.79 32.95 178.35 114.44 131.34 111.74 129.79 30.26 176.79",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "111.74 129.79 32.95 175.23 32.95 76.28 111.74 30.83 111.74 129.79",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.55,153.05c0,3.16,2.22,4.44,5,2.86l45.84-26.47a10.94,10.94,0,0,0,5-8.58V35.39L43.55,67.57Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.36,78.46c-.66-3.75-3.62-6.54-7.87-.66s-7.23,16.31-11.34,19c-2.59,1.77-6.29-3-9.52-4.14s-7.42.19-10.07,11.13-2.26,15.12-.34,16.8c2.67,2.32,6.43.43,9.42-.09s.43,4.77,1.66,7.79,4.23,2.49,6-1.45c.36-.79.69-1.57,1-2.31,1-2.38,2.75-3.58,3.82-2.51a8.84,8.84,0,0,0,.8.71c2.26,1.7,5.63-3.23,5.46-7.28s-.32-6.84,1.29-8.64,6-3,8.28-8S92,82.22,91.36,78.46ZM64.15,106.75A9.76,9.76,0,0,1,63,109.86a18,18,0,0,1-1.51,2.48,6.71,6.71,0,0,1-3.64,2.39,2.3,2.3,0,0,1-1.57,0c-2-.92-.66-7.52.16-10.53a13.9,13.9,0,0,1,1.43-3.52,3.63,3.63,0,0,1,.6-.74,2.63,2.63,0,0,1,2.38-.61,2.36,2.36,0,0,1,1.56.85,5.42,5.42,0,0,1,.63,1.5c.26.77.5,1.54.75,2.32A5.91,5.91,0,0,1,64.15,106.75Zm4.33,16.66A3,3,0,0,1,67,125a1.52,1.52,0,0,1-.82-.1,1.37,1.37,0,0,1-.69-.41,1.46,1.46,0,0,1-.26-1.13,3.8,3.8,0,0,1,.63-1.49c.61-1,1.2-1.88,1.74-3,.43-.82.82-1.44,1.34-1.16C70,118.35,69.33,121.78,68.48,123.41ZM78,118.25c-.52.66-1.11,1.37-1.65,1.37s-.69-.44-.89-.93a6.35,6.35,0,0,1-.41-1.49,5.24,5.24,0,0,1,0-2.15c.64-2.54,2.1-1.29,2.89-.94S79.13,116.85,78,118.25ZM89,87.53a43.78,43.78,0,0,1-.79,6.29,7,7,0,0,1-.69,2.11A1.87,1.87,0,0,1,86,97a5.4,5.4,0,0,1-3.24-1,4.25,4.25,0,0,1-2.07-3.3,8.59,8.59,0,0,1,.81-3c.47-1.2.83-2.47,1.37-3.64a6.38,6.38,0,0,1,1.69-2.34,1.89,1.89,0,0,1,1.73-.32,5.78,5.78,0,0,1,1,.43,2.62,2.62,0,0,1,1.59,1.76A7.52,7.52,0,0,1,89,87.53Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.83,125.27c-1.51-.87-1.83.31-4,.55s-2.66-1.38-4.4-1.1-3.57,5.74-1.29,6.93,3,1.13,3,3.18-.28,14-.28,14L60,145.31s0-11,0-12.43.53-2.41,1-4.21C61.19,127.57,61.61,125.72,60.83,125.27Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.31,111.41c1.5-2.61,1.34-1.28,3.9-3.11,1.47-1.07,1.57-2.63,3.31-4.36s4.58,1.1,2.31,4.91S89,114.93,89,117s.26,11.41.26,11.41L83.12,132s0-11.06,0-12.49a13.64,13.64,0,0,0-.56-4.25C82.29,114.42,81.53,112.76,82.31,111.41Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.42,86.53c-3.15,1.83-4.94,1.41-5.35,2.46s-.16,1.85.33,2.16c1.09.67,3.6-.22,5-.83a10.6,10.6,0,0,0,4-3.37c.78-1.32.73-3,.3-3.48C74.89,83.49,74.35,84.84,71.42,86.53Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.42,79.42c-3.15,1.83-4.94,1.41-5.35,2.46s-.16,1.85.33,2.16c1.09.67,3.6-.22,5-.83a10.6,10.6,0,0,0,4-3.37c.78-1.32.73-3,.3-3.48C74.89,76.38,74.35,77.73,71.42,79.42Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.42,72.32c-3.15,1.82-4.94,1.4-5.35,2.45s-.16,1.85.33,2.16c1.09.68,3.6-.22,5-.83a10.52,10.52,0,0,0,4-3.37c.78-1.32.73-3,.3-3.48C74.89,69.27,74.35,70.62,71.42,72.32Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.19,75.05,59.69,69c.54-.32,1-.06,1,.57v5.65a2.16,2.16,0,0,1-1,1.71L49.19,83c-.55.32-1,.06-1-.57V76.77A2.18,2.18,0,0,1,49.19,75.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.13,24.61,30.26,74.72V183l86.87-50.11Zm-2.69,106.73L33,178.35V76.28l81.49-47Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "114.44 131.34 111.74 129.79 111.74 30.83 114.44 29.27 114.44 131.34",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "117.13 24.61 114.44 23.05 27.56 73.17 30.26 74.72 117.13 24.61",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "27.56 73.17 30.26 74.72 30.26 183.01 27.56 181.46 27.56 73.17",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "27.56 68.9 32.95 72.01 119.82 21.9 114.44 18.79 27.56 68.9",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "32.95 72.01 32.95 80.54 119.82 30.42 119.82 21.9 32.95 72.01",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "27.56 68.9 32.95 72.01 32.95 80.54 27.56 77.43 27.56 68.9",
    style: {
      fill: "#e0e0e0"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Furnitures--inject-13"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Table--inject-13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.46,363.11H65.92l-1.67,10.2h0a1.89,1.89,0,0,1-1,1.26,5.55,5.55,0,0,1-5,0,1.89,1.89,0,0,1-1-1.26h0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.46,363.11H65.92l-1.67,10.2h0a1.89,1.89,0,0,1-1,1.26,5.55,5.55,0,0,1-5,0,1.89,1.89,0,0,1-1-1.26h0Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192,284.3h10.46l-1.67,10.2h0a1.87,1.87,0,0,1-1,1.26,5.57,5.57,0,0,1-5.06,0,1.84,1.84,0,0,1-1-1.26h0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192,284.3h10.46l-1.67,10.2h0a1.87,1.87,0,0,1-1,1.26,5.57,5.57,0,0,1-5.06,0,1.84,1.84,0,0,1-1-1.26h0Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9,345.44H35.36l-1.68,10.2h0a1.89,1.89,0,0,1-1,1.26,5.55,5.55,0,0,1-5,0,1.89,1.89,0,0,1-1-1.26h0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9,345.44H35.36l-1.68,10.2h0a1.89,1.89,0,0,1-1,1.26,5.55,5.55,0,0,1-5,0,1.89,1.89,0,0,1-1-1.26h0Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "22.32 234.9 22.32 349.95 60.75 372.17 60.75 257.11 22.32 234.9",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "60.75 372.17 208.75 286.73 208.75 171.68 60.75 257.11 60.75 372.17",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.75,173.41V286.16l-146,84.28V257.69l146-84.28m1-1.74-148,85.44V372.17l148-85.44V171.67Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "102.31 348.17 104.37 346.98 104.37 231.92 102.31 233.11 102.31 348.17",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "172.43 307.69 174.49 306.5 174.49 191.44 172.43 192.63 172.43 307.69",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.2,172.37a1.56,1.56,0,0,0-.91-1.28l-41.88-24.2a4.91,4.91,0,0,0-4.42,0L16.67,233.62a1.55,1.55,0,0,0-.92,1.27v2.94a1.55,1.55,0,0,0,.92,1.27l41.88,24.21a4.85,4.85,0,0,0,4.42,0l150.32-86.78a1.54,1.54,0,0,0,.91-1.27Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.75,234.89v2.94a1.55,1.55,0,0,0,.92,1.27l41.88,24.21a4.53,4.53,0,0,0,2.2.53L89.44,218l-30.07-9-42.7,24.65A1.55,1.55,0,0,0,15.75,234.89Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167,146.89,16.67,233.62a1.35,1.35,0,0,0,0,2.55l41.88,24.21a4.85,4.85,0,0,0,4.42,0l150.32-86.74a1.35,1.35,0,0,0,0-2.55l-41.88-24.2A4.91,4.91,0,0,0,167,146.89Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.43,265.21c0,.71,2.12.06,4.74-1.46l6.25-3.59c2.62-1.52,4.74-3.33,4.74-4v-1.28l-15.73,9.08Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.52,204c0,.71,2.12.06,4.74-1.45l6.25-3.6c2.62-1.51,4.74-3.32,4.74-4v-1.29l-15.73,9.09Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.77,243.86c0,.71,2.12.06,4.74-1.45l6.25-3.6c2.62-1.51,4.74-3.32,4.74-4v-1.29l-15.73,9.09Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.77,271.12c0,.7,2.12.05,4.74-1.46l6.25-3.6c2.62-1.51,4.74-3.32,4.74-4v-1.28l-15.73,9.08Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.77,310.25c0,.71,2.12.06,4.74-1.45l6.25-3.6c2.62-1.51,4.74-3.32,4.74-4v-1.29L129.77,309Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "173.46 235.52 103.02 276.19 103.02 278.46 173.46 237.79 173.46 235.52",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "173.46 274.66 103.02 315.33 103.02 317.6 173.46 276.93 173.46 274.66",
    style: {
      fill: "#e6e6e6"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--table--inject-13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M443.66,363.11H433.2l1.67,10.2h0a1.89,1.89,0,0,0,1,1.26,5.55,5.55,0,0,0,5.05,0,1.89,1.89,0,0,0,1-1.26h0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.66,363.11H433.2l1.67,10.2h0a1.89,1.89,0,0,0,1,1.26,5.55,5.55,0,0,0,5.05,0,1.89,1.89,0,0,0,1-1.26h0Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.13,284.3H296.67l1.67,10.2h0a1.87,1.87,0,0,0,1,1.26,5.57,5.57,0,0,0,5.06,0,1.84,1.84,0,0,0,1-1.26h0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.13,284.3H296.67l1.67,10.2h0a1.87,1.87,0,0,0,1,1.26,5.57,5.57,0,0,0,5.06,0,1.84,1.84,0,0,0,1-1.26h0Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.22,345.44H463.76l1.68,10.2h0a1.89,1.89,0,0,0,1,1.26,5.55,5.55,0,0,0,5,0,1.89,1.89,0,0,0,1-1.26h0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.22,345.44H463.76l1.68,10.2h0a1.89,1.89,0,0,0,1,1.26,5.55,5.55,0,0,0,5,0,1.89,1.89,0,0,0,1-1.26h0Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "476.8 234.9 476.8 349.95 438.37 372.17 438.37 257.11 476.8 234.9",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "438.37 372.17 290.37 286.73 290.37 171.68 438.37 257.11 438.37 372.17",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.37,173.41l146,84.28V370.44l-146-84.28V173.41m-1-1.74V286.73l148,85.44V257.11l-148-85.44Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "396.81 348.17 394.75 346.98 394.75 231.92 396.81 233.11 396.81 348.17",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "326.69 307.69 324.63 306.5 324.63 191.44 326.69 192.63 326.69 307.69",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.92,172.37a1.56,1.56,0,0,1,.91-1.28l41.88-24.2a4.91,4.91,0,0,1,4.42,0l150.32,86.73a1.55,1.55,0,0,1,.92,1.27v2.94a1.55,1.55,0,0,1-.92,1.27l-41.88,24.21a4.85,4.85,0,0,1-4.42,0L285.83,176.53a1.54,1.54,0,0,1-.91-1.27Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.37,234.89v2.94a1.55,1.55,0,0,1-.92,1.27l-41.88,24.21a4.53,4.53,0,0,1-2.2.53L409.68,218l30.07-9,42.7,24.65A1.55,1.55,0,0,1,483.37,234.89Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.13,146.89l150.32,86.73a1.35,1.35,0,0,1,0,2.55l-41.88,24.21a4.85,4.85,0,0,1-4.42,0L285.83,173.64a1.35,1.35,0,0,1,0-2.55l41.88-24.2A4.91,4.91,0,0,1,332.13,146.89Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.69,265.21c0,.71-2.12.06-4.74-1.46l-6.25-3.59c-2.62-1.52-4.74-3.33-4.74-4v-1.28l15.73,9.08Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.6,204c0,.71-2.12.06-4.74-1.45l-6.25-3.6c-2.62-1.51-4.74-3.32-4.74-4v-1.29l15.73,9.09Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.35,243.86c0,.71-2.12.06-4.74-1.45l-6.25-3.6c-2.62-1.51-4.74-3.32-4.74-4v-1.29l15.73,9.09Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.35,271.12c0,.7-2.12.05-4.74-1.46l-6.25-3.6c-2.62-1.51-4.74-3.32-4.74-4v-1.28l15.73,9.08Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.35,310.25c0,.71-2.12.06-4.74-1.45l-6.25-3.6c-2.62-1.51-4.74-3.32-4.74-4v-1.29L369.35,309Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "325.66 235.52 396.11 276.19 396.11 278.46 325.66 237.79 325.66 235.52",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "325.66 274.66 396.11 315.33 396.11 317.6 325.66 276.93 325.66 274.66",
    style: {
      fill: "#e6e6e6"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-3--inject-13"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M374.53,203.14l-2.85,96.52s25.45-6.31,48.25-2.41,28.26,9.21,28.26,9.21l-14.72-142-52.63,1.6S374.53,174.71,374.53,203.14Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bottom--inject-13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M442.35,421.12c.21,5,1,7.63,3,10.34a8.75,8.75,0,0,0,9.39,3c3.55-1,7.25-4,8.07-8.17a26.28,26.28,0,0,0-.78-11.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.2,337.44c-2.7-14.34-5.7-20.76-6.27-24,0,0-4-33.87-5.76-62.71-.86-13.87-.55-23.21-8.82-39.31l-48.12,13c-.59,7.38-5.11,57.69-2.89,101.06,1.83,35.61,4.21,52.38,4.46,58.33.13,3.37.07,5.61-.07,10.29-.05,1.9-1.36,3.22-2.12,4.59a15.61,15.61,0,0,1-4.17,4.21c-3.64,2.86-5.82,4.76-10.11,6.43a9.58,9.58,0,0,0-2.38,1.17,3,3,0,0,0-1.28,2.26,3.7,3.7,0,0,0,2.14,2.91c3.87,2.24,8.71,1.81,12.95.44s8.17-3.62,12.43-4.92c2.95-.9,6.08-1.36,8.78-2.86a4.51,4.51,0,0,0,2.11-2.07,5.35,5.35,0,0,0,.21-2.52,60.86,60.86,0,0,1-.6-8.63c.08-3.55.58-10.13.85-13.68.22-3,3.69-29.6,3.16-42.87a91.75,91.75,0,0,1,.39-12.15l4.27-47.12c2,7.88,9.21,30.68,11.48,41.1,2.76,12.74,7.42,28.88,13.19,52.18,1.62,6.56,4.58,14.69,5.33,18.65s1.73,16.28,3.93,21.83c3.35,8.42,12.84,8.39,13.7,1.08.74-6.21-3.24-23.23-3.4-27.31S455.34,354.15,452.2,337.44Z",
    style: {
      fill: "#c8856a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.09,392.09c.79,5,1.47,8.79,2,11.68,1.48,4.94,2.06,7.33,2.89,10.53,1.36,5.25,1.1,9.95-.37,12.75-2.18,4.18-11,8.49-15.64,3.11-3.79-4.38-3.63-6.47-3.62-13v-5.63c-.11-5.83-.2-7-1.08-10.66-.5-2.11,0-5.33-.43-7.57-.44-2.43-.62-3.49.13-3.88,0,0,.39,3.12.87,5.37.45,2.07.8,4.16,1.22,6.23.51,2.55.95,5.11,1.67,7.62.08.27.21.6.49.64s.56-.39.58-.74a1.55,1.55,0,0,1,.36-1.15,4.19,4.19,0,0,1,1.26-.77,12.24,12.24,0,0,1,2.79-.75,12,12,0,0,1,4.13-.17,2.28,2.28,0,0,1,1.13.48,7.37,7.37,0,0,1,.65.9c.2.21.56.33.77.13a.7.7,0,0,0,.18-.44,8,8,0,0,0,.05-1.76c-.11-3.27-.33-6.47-.75-9.71a47.66,47.66,0,0,1-.7-7.72A9.88,9.88,0,0,1,457.09,392.09Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406,407.25,357,418.06a3.86,3.86,0,0,0,.39,3.47c1.79,2.29,7.83,5.38,15.3,4.45s11.53-4.25,14.29-6.35a20.5,20.5,0,0,1,4.62-2.85c1.78-.8,4.4-.84,6.29-1.11a33.57,33.57,0,0,0,4.95-1.42,10.26,10.26,0,0,0,3.29-1.79,13.87,13.87,0,0,0,.23-2.82C406.26,408.94,406.15,407.94,406,407.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.74,402.41a15.48,15.48,0,0,1,5.66-3.73c1.75-.82,2.24-1.59,2.29-3.63,0-.18,1.43-.07,1.66.18A2.61,2.61,0,0,1,405,397c.12,1.53.3,2.25.54,3.84.55,3.53,1.33,4.65.81,8.8-2.2,2.95-9,4.37-12.62,4.85-5.68.77-10.26,5.8-14.55,7.3-7.86,2.75-15.56,1.27-18.55-.32-3.45-1.83-5.39-4.87-2.55-7.06,1.73-1.34,11.57-6.69,13.34-7.7,1.4-.81,2.74-1.76,4.12-2.62a2.1,2.1,0,0,1,.74-.35,2.17,2.17,0,0,1,.94.1,25.88,25.88,0,0,1,5,1.83,2.33,2.33,0,0,1,1.33,1.26c.3,1.05-1.69,2.91-.49,3.25s2.94-1.18,3.8-1.67a26.46,26.46,0,0,0,7.78-6A1.47,1.47,0,0,1,394.74,402.41Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.32,208.79l-.51,5.36c-4.64,29.65-5.06,68.93-4.57,80.87,1.45,35.19,2.06,105.44,2.06,105.44s5.1,4.12,13.95,3.73A37,37,0,0,0,406,401.86s2.58-49.41,3.1-59.58a110.28,110.28,0,0,0-.26-13,93,93,0,0,1,.18-16.26l2.46-30.05s9.1,41.63,10,46.69C425.88,355,438.28,401,438.28,401a33.47,33.47,0,0,0,12.71.16c6.69-1.29,8.2-4.78,8.2-4.78s-4.5-50.28-5.55-60.55c-1.4-13.73-2.69-20.11-3.64-25.74-1.12-6.61-1.66-31.54-2.42-46-.52-9.9-.88-17.41-2-24.68-2.29-15.18-9-24.33-11.58-29.92l-.39-3C426.09,213.13,397.46,217.27,383.32,208.79Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.52,282.94l-7.13-28.36s-9.25-1.94-13.8-7.43c0,0,1,6.93,10.61,10.47l6.74,24.78,1.26,29.12Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Top--inject-13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M445.83,122.76c2.33-4.5,4.19-10.47,0-14.5,1.84-5,3.12-11.39-2-14.77.12-6.53-3.3-10.7-8.27-12.44-4.7-1.65-9.82-1.13-13.44,3.09l3.49,1.64c.52,4.45,2.05,8.77,6.16,11-1.65,5.15-.73,9.44,4.47,11.81-2.87,5.14-3.15,11,.73,15.69-1.75,4.32-1.06,7.94,1.82,11.57-3,3.61-1.23,8.69,2.16,11.46a9,9,0,0,0-2.62,7.2,6.12,6.12,0,0,0,5.68,5.9c-1.61-1.29-1.77-2.17-.93-4.62s2.3-5.38,0-8.09c2.27-3.88,4.44-8.29,1.73-12.41C446.84,131.26,448.36,126.9,445.83,122.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.27,85.2c1.24-2.12,4-1.27,6.27.64s4.36,5.18,3.11,7C431.53,95.8,423.08,87.27,424.27,85.2Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Arm--inject-13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M340.71,162c4.29,3.73,19.2,14.49,19.2,14.49s12.43-16.19,15-19.66c7.43-9.92,13.11-16.87,22.15-16.62l3.6,25.65c-6.81,8.86-24.48,24.63-31.86,32.37-3.87,4.06-8.55,3.37-12.57.87-8.4-5.25-26.95-27.82-26.95-27.82Z",
    style: {
      fill: "#c8856a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.72,139.84c-5.31.25-9.11,2.71-12.5,6.21s-23.55,30.09-23.55,30.09l-7.26-5.28A25.3,25.3,0,0,1,348,183c-4,5.38-7.16,3.38-7.16,3.38s7.76,8.65,11.29,11.48,7.91,5,11.51,4.37,4.75-1.64,13.25-10.25,24.46-24.69,24.46-24.69Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.67,176.14a23,23,0,0,1,7.65,9.65,18.41,18.41,0,0,0-6.49-11.18Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.4,165.75c-5.49-4.38-8.79-8-8.82-13.36s.7-8.12.26-9.32-4.58-6.33-5.74-8.83-2.34-2.27-4.5-3.17c-2.61-1.08-13.07-3.5-13.14-2.69a4.36,4.36,0,0,0,2.15,4.75c1.9,1.14,7.55,2.71,7.55,2.71s-1.81,2.2-2.68,3.13-.7,1.69.56,4.71c0,0-1.42.62-1.62,1.73a6.49,6.49,0,0,0,.58,3.24,3,3,0,0,0-1.32,1.38c-.42,1,.43,3.5,1.47,5.64a34,34,0,0,0,1.46,8.1c.94,2.7,2.68,3.76,4.64,5,1.32.8,4.95,4.74,6.39,6.24C332.64,175,350.42,169.76,345.4,165.75Z",
    style: {
      fill: "#c8856a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.83,144.13a10,10,0,0,1-3.86-5.19c-.6-2.1-1.12-4.47-1.81-4.49-1.17,0-3.38,2.25-2.71,5.75.64,3.34,2.26,7.25,2.38,8.22s-.69,3.27-1.39,5a9.24,9.24,0,0,0,3.15,10.11,8.57,8.57,0,0,1-4.32-4.67c-1.64-3.7.56-7.46,1-9.25s.52-2.15-.6-5.21-2.35-6.34,0-9.36,3.46-1.57,3.88-.58S330.74,141.87,333.83,144.13Z",
    style: {
      fill: "#af6152"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.16,135.84l2.17,1.06-.69.57a2.82,2.82,0,0,0-3,.21Z",
    style: {
      fill: "#af6152"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321,143.68c.38,1,1.75,4.06,2,4.68s1.46.41,2.14-.78a4.46,4.46,0,0,0,.68-3.21,4.83,4.83,0,0,1-.17,3.45c-.82,1.56-1.94,1.76-2.62,1.56S321.86,145.82,321,143.68Z",
    style: {
      fill: "#af6152"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320,148.65c.27.76.82,1.73,1.63,3.82.46,1.21.71,2,1.46,1.89s2-1.69,1.85-3.16a10.84,10.84,0,0,0-.61-2.5l.59-.26a8.54,8.54,0,0,1,.64,4c-.3,1.77-2,3.17-2.77,2.71s-1-1.14-1.61-2.89S320,148.65,320,148.65Z",
    style: {
      fill: "#af6152"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.53,154.54c.12.51-.14,1.67-1,1.71a1.84,1.84,0,0,1-1.39-.58,1.56,1.56,0,0,0,1.49,1c1-.06,1.51-1.12,1.67-2Z",
    style: {
      fill: "#af6152"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chest--inject-13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M423.51,138.47l13.76,3.67c2.74.93-.35,17.09.41,35.59.79,19,1.47,49.66,1.47,49.66s-8.17,4.38-31.25,5c-14.44.39-27.74-7.61-27.74-7.61l2.65-22V183.27s-8.1-9.86-3.55-21.14,20.3-25.93,20.3-25.93l7.07.34Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.51,138.47l13.76,3.67c2.74.93-.35,17.09.41,35.59.79,19,1.47,49.66,1.47,49.66s-8.17,4.38-31.25,5c-14.44.39-27.74-7.61-27.74-7.61l2.65-22V183.27s-8.1-9.86-3.55-21.14,20.3-25.93,20.3-25.93l7.07.34Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.2,180.07a15.33,15.33,0,0,1-13.48,6.64,15.12,15.12,0,0,1-12.13-7.35s1.58,9.52,13,9.73S425.2,180.07,425.2,180.07Z",
    style: {
      fill: "#BA68C8",
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M407.16,137.12c-5.68,4.74-14.53,11.12-19.78,18-10.6,13.86-12,26.43-12.85,42.56-.17-24.08-4-37.47,25-62.37,5.18-4.45,7.23-5.44,7.23-5.44Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Head--inject-13"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--head--inject-13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M389.69,104c-10.59-21.13,10.4-25.58,23.54-23.31,13.82,2.38,26.86,11.75,22.69,29.83-1.81,7.81-6.33,13.56-9.9,20.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.61,106.58c-4.56-1.79-6.64,3-6.64,3-2.84,1.93-4.2-1.84-4.78-3.63-2.12-6.61-1.08-11.37-6.66-13.28-2.56-.88-4.92,1.22-7.19,2.7A5.42,5.42,0,0,1,401,96.5c-1.4-.33-4-2.42-5.3-3C392,91.63,390.8,96.14,390,101a61.39,61.39,0,0,0-.28,11.85c.77,13,2.85,17.56,7.88,20,2.25,1.11,5,1.33,9.34.8l.35,5.6a42.79,42.79,0,0,0-7,20.5s10.24-4.48,16-9.29c10-8.36,10.19-13.5,10.19-13.5l-1.1-16.87c.85,1.08,4.31,1.21,6.29-1.4C435.16,114.13,435,108.29,430.61,106.58Z",
    style: {
      fill: "#c8856a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407,133.71c4.19-.81,11.81-3.45,13-7,0,0,.3,2.81-2.87,5.42-2.64,2.19-10,3.77-10,3.77Z",
    style: {
      fill: "#af6152"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M407.44,121.27l-4.3,1.42a2.22,2.22,0,0,0,2.82,1.52A2.37,2.37,0,0,0,407.44,121.27Z",
    style: {
      fill: "#af6152"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.66,102.5l4.33-1.33a2.18,2.18,0,0,0-2.76-1.54A2.37,2.37,0,0,0,392.66,102.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413,103.23l-4-2.06a2.17,2.17,0,0,1,3-1A2.38,2.38,0,0,1,413,103.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393,109.94a1.84,1.84,0,1,0,1.92-1.84A1.87,1.87,0,0,0,393,109.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.27,110.57a1.84,1.84,0,1,0,1.92-1.84A1.88,1.88,0,0,0,407.27,110.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.07,104.67a3.24,3.24,0,0,0,.62,1.87,1.41,1.41,0,0,1,.26.67,32.34,32.34,0,0,0,.63,5.13,5.06,5.06,0,0,0,5.11,3.78,7.93,7.93,0,0,0,1.88-.13l.15,0a5.63,5.63,0,0,0,1.57-.59l.1-.05.13-.09.18-.11.16-.11.17-.14.17-.14a2.27,2.27,0,0,0,.32-.3,8.18,8.18,0,0,0,1.39-2c.93-1.78.93-4.28,2.24-4.54l.16,0h.17c1.74,0,1.34,2.77,2.17,4.74s2.34,4,6.19,4.07h.5l.4,0a8.6,8.6,0,0,0,.94-.12l.29-.07.29-.08.17,0a5.67,5.67,0,0,0,1.08-.48l.36-.24a4.54,4.54,0,0,0,.63-.53,6.51,6.51,0,0,0,1.26-1.82c.66-1.35.94-3.8,1.29-5.06a2.28,2.28,0,0,1,.33-.73,3.55,3.55,0,0,0,.93-1.79,1.5,1.5,0,0,0-1-1.59l-.92-.13c-2.94-.41-6.8-.63-9.15,0-3,.75-4,1.67-5.66,1.62s-2.41-1-5.08-2c-2.13-.74-5.73-.78-8.51-.57l-.87.08C386.68,103.16,386.1,103.87,386.07,104.67Zm19,2.13a2.91,2.91,0,0,1,.88-.67l.15-.08.09,0,.42-.19.39-.15a11.14,11.14,0,0,1,1.27-.37l.5-.11q.64-.12,1.29-.18l.3,0c2.82-.18,4.53.51,5.13,1.09s.2,3.23-.14,4.57l0,.1a.36.36,0,0,0,0,.1c0,.17-.09.35-.15.55a3.19,3.19,0,0,0-.11.33v0a5.85,5.85,0,0,1-.22.56h0l-.09.19a.61.61,0,0,1-.05.12s-.05.08-.07.13l-.09.16a1,1,0,0,1-.1.17,1.27,1.27,0,0,1-.13.19,1.27,1.27,0,0,1-.13.19,4.64,4.64,0,0,1-4.1,1.86,5.16,5.16,0,0,1-4.1-1.71h0a5.66,5.66,0,0,1-1.18-2.76C404.5,109.34,404.43,107.6,405,106.8Zm-16.36-1.64a2.81,2.81,0,0,1,.73-.42l0,0,.32-.12.19,0,.15,0,.11,0h0l.16,0,.65-.1.35,0h1.14a12.61,12.61,0,0,1,1.27.14c2,.32,4,1.29,4.44,2.12s.21,2.57-.18,4.05a7.9,7.9,0,0,1-.34,1s0,0,0,.08a1,1,0,0,1,0,.1l0,.07-.06.12-.13.25-.13.21a.18.18,0,0,1-.05.07l-.09.15-.09.12a0,0,0,0,0,0,0,4.8,4.8,0,0,1-4.41,1.9,4.6,4.6,0,0,1-2.08-.56c-1.91-1.07-2.18-3.38-2.31-4.44C388.13,108.36,388,105.73,388.68,105.16Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417,104.42l8.87,2.74a7.85,7.85,0,0,0-1.66,2l-7.16-2.1Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.12,108.1l-1,11.59-6.32-2,6.6-9.83A1.42,1.42,0,0,1,402.12,108.1Z",
    style: {
      fill: "#af6152"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M426.27,133.94c-.42,6-2.69,14.57-3.26,30.83s4.39,141.64,4.39,141.64,17.22,2.18,29.9-5.05c0,0-4.5-51.73-14.26-94.32-2.53-11,2.09-24.74,3-39.62a62.69,62.69,0,0,0-3.11-23.9s-9.22-3.08-12-4.72A14.76,14.76,0,0,1,426.27,133.94Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.09,137a13.08,13.08,0,0,0,3.26,2.8c2.52,1.47,9.7,3.95,11.72,4.64a63.12,63.12,0,0,1,2.86,22.94C444.6,172.74,443.77,178,443,183c-1.38,8.76-2.69,17.05-1,24.26,9,39.3,13.58,87,14.17,93.44-7.42,4-16.32,4.86-22.55,4.86-2.26,0-4.05-.12-5.08-.21-.46-11.78-4.89-125.28-4.35-140.57a188,188,0,0,1,2.34-23.6c.23-1.53.45-2.94.62-4.24m-.82-3c-.42,6-2.69,14.57-3.26,30.83s4.39,141.64,4.39,141.64a54,54,0,0,0,6.16.31c6.16,0,15.83-.85,23.74-5.36,0,0-4.5-51.73-14.26-94.32-2.53-11,2.09-24.74,3-39.62a62.69,62.69,0,0,0-3.11-23.9s-9.22-3.08-12-4.72a14.76,14.76,0,0,1-4.65-4.86Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--arm--inject-13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M385,220.71a10.42,10.42,0,0,1,2.09.08c.77.1,1.48.24,2.26.27s1.63,0,2.45,0c1.14,0,2.3,0,3.44,0a25.61,25.61,0,0,0,6.37-1.26c.66-.22,1.31-.47,2-.74.29-.13.64-.38.55-.69a.67.67,0,0,0-.41-.34c-.93-.41-1.93-.65-2.9-1a6,6,0,0,1-2.58-1.58c-.47-.54-1.27-2.16-.6-2.83.51-.5,1.81,0,2.39.09a21.79,21.79,0,0,0,3.76.59c1.36.07,2.73-.09,4.09,0a14,14,0,0,1,5.14,1.17c1.53.67,3,1.59,4.54,2.13,3,1,7.36-.12,11.21-1.42,7.88-2.67,21.46-9.52,21.46-9.52l-8.26-30c-3.38-8-4.69-28-.65-31.48,2.09.27,9-.56,14.62,5.56,3.08,3.33,5.14,11.5,9.37,26.67,3,10.8,5.43,20.95,7.21,30.89,2,11.05-2,14.82-11.93,17.05C444,228.06,431,231.5,424.37,232l-.34,0c-3.26.27-6.51.73-9.77,1-1.67.15-3.38.13-5,.38a10.74,10.74,0,0,1-6.29-.65c-2.44-1.18-4.24-3.73-6.93-4.13a16.29,16.29,0,0,1-2.42-.27c-1.36-.41-2.2-1.67-3.34-2.44a13,13,0,0,0-2.34-1l-2.6-1.1a12.48,12.48,0,0,1-1.84-.89,1.59,1.59,0,0,1-.48-.41C382.19,221.37,384.33,220.76,385,220.71Z",
    style: {
      fill: "#c8856a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.29,142.7c12.49,2.55,14,3.18,17.33,8.48,4.08,6.4,7,20.13,11.65,37.7a154.45,154.45,0,0,1,4.55,23.61c.19,2.91-1,9.41-8,11.16s-16.37,3.74-16.37,3.74,2-13.5-4.39-19.53l4.74-2.4L439.7,174.83S433.27,151.44,440.29,142.7Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.82,205.46a23.4,23.4,0,0,1,12.35.4s-3.23-3.73-13.12-3Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M434.71,140.47c-2.27-1-5.81-3.6-6.77-5.43s-.89-2.71-1.77-2.7l.11,1.7s-4,14.68-3.92,29l0,0c-.16,9.82.86,22.46.86,22.46,2.95-6.95,6.07-16.6,6.07-16.6l-3.75-9C427.93,151,433.06,145.21,434.71,140.47Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.29,147l-.74-.85c7.57-6.6,13.14-16.93,13.72-18.27,0,0,1.41-4,.23-10.56l1.11-.2c1.24,6.9-.23,11-.29,11.18C429.6,130,424,140.25,416.29,147Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.33,133.91l-1.08,2a2.1,2.1,0,0,0-1-.47c.33-.65.65-1.23.93-1.73A8.74,8.74,0,0,0,401.33,133.91Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.67,113.81h0a2.58,2.58,0,1,0-2.75,3.67h0s1,0,1.33,1.49a9.88,9.88,0,0,1,.29,2.85,1.51,1.51,0,0,0,1.82-.4C431.76,119.43,431.44,115.11,430.67,113.81Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.82,198.41a36.52,36.52,0,0,1-14.58-3c-8.92-3.88-23.89-15.25-23.89-47.73h2.25c0,23.12,8,39.34,22.54,45.66,13.49,5.87,28.57,1.76,35.92-5.09,6.9-6.42,8.54-13.78,10-20.28.78-3.52,1.52-6.84,3-9.54l2,1.1c-1.35,2.42-2,5.43-2.81,8.93C393.8,175,392,183,384.6,189.92,379.35,194.81,370.43,198.41,360.82,198.41Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.82,198.41a36.52,36.52,0,0,1-14.58-3c-8.92-3.88-23.89-15.25-23.89-47.73h2.25c0,23.12,8,39.34,22.54,45.66,13.49,5.87,28.57,1.76,35.92-5.09,6.9-6.42,8.54-13.78,10-20.28.78-3.52,1.52-6.84,3-9.54l2,1.1c-1.35,2.42-2,5.43-2.81,8.93C393.8,175,392,183,384.6,189.92,379.35,194.81,370.43,198.41,360.82,198.41Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.87,140.85a107.41,107.41,0,0,1-9.45,10c-2.32,1.88-8.65,6.83-13.09,8.65a7.72,7.72,0,0,1-2.75.69,2.52,2.52,0,0,1-.75-.1c-.78-.26-3.14-1-2.43-14.24.13-2.32,3.48-8.88,4.16-10.16a.62.62,0,0,1,.65-.21,2.1,2.1,0,0,1,1,.47c.28.25.44.53.3.78-1.46,2.81-3.81,7.81-3.89,9.24-.36,6.75.19,11.4.93,12,.47.16,1.57-.24,3-1a79.87,79.87,0,0,0,11.34-7.82,108.17,108.17,0,0,0,9.16-9.69C421.72,138.83,423.3,140.29,422.87,140.85Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.87,140.85a107.41,107.41,0,0,1-9.45,10c-2.32,1.88-8.65,6.83-13.09,8.65a7.72,7.72,0,0,1-2.75.69,2.52,2.52,0,0,1-.75-.1c-.78-.26-3.14-1-2.43-14.24.13-2.32,3.48-8.88,4.16-10.16a.62.62,0,0,1,.65-.21,2.1,2.1,0,0,1,1,.47c.28.25.44.53.3.78-1.46,2.81-3.81,7.81-3.89,9.24-.36,6.75.19,11.4.93,12,.47.16,1.57-.24,3-1a79.87,79.87,0,0,0,11.34-7.82,108.17,108.17,0,0,0,9.16-9.69C421.72,138.83,423.3,140.29,422.87,140.85Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.12,143.82a7.57,7.57,0,0,0-3.16-6,2,2,0,0,0-2.07-.16l-2.51,1.45a2.83,2.83,0,0,0-1.09,2.56,7.58,7.58,0,0,0,3.17,6,2,2,0,0,0,2.06.16l2.51-1.45A2.8,2.8,0,0,0,329.12,143.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 323.46,
    cy: 143.45,
    rx: 2.75,
    ry: 4.85,
    transform: "matrix(0.92, -0.39, 0.39, 0.92, -30.34, 138.1)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.63,147.05c0-4.26-2.6-9.22-5.79-11.06a3.72,3.72,0,0,0-3.79-.31l-1.61.93c-1.22.71-2,2.35-2,4.68,0,4.26,2.59,9.21,5.79,11.06a3.67,3.67,0,0,0,3.78.3l1.61-.92C326.85,151,327.63,149.38,327.63,147.05Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326,148c0,4.27-2.6,6.23-5.79,4.38s-5.79-6.8-5.79-11.06,2.59-6.23,5.79-4.38S326,143.71,326,148Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.74,147.23c0,3.32-2,4.84-4.5,3.4s-4.51-5.28-4.51-8.6,2-4.84,4.51-3.41S324.74,143.91,324.74,147.23Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330,138.94c-.6-2.1-1.12-4.47-1.81-4.49-1.17,0-3.38,2.25-2.71,5.75.64,3.34,2.26,7.25,2.38,8.22l6-4.29A10,10,0,0,1,330,138.94Z",
    style: {
      fill: "#c8856a"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-13"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chartacter--inject-13"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--bottom--inject-13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M151,421.18c.32,0,.58,3.22-1.22,4.45-2.09,1.42-8.06,3.58-15.66,2.16s-11.6-3.87-14.51-6.41-7-6.14-10.4-7.07c-3.18-.87-6.58-2.43-7.55-3.41s-.55-5-.55-5Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.23,390.58a1.22,1.22,0,0,0-1.22.87c-.31,1.09-.79,4.31-1.42,6.1-.87,2.49-1.7,7.65-1.41,9.75s5.43,3.88,8.7,5.27a43.81,43.81,0,0,1,10.45,7c3.41,2.95,10.8,6.27,15.79,6.58,5.92.36,12.69-.93,14.38-3.33,2.1-3,3.71-6.46-4.8-10.75-1.61-.81-7.22-4.35-9.13-5.63-5.16-3.44-8.75-6.53-10.85-12.15a2.34,2.34,0,0,0-2.84-2c-1.47.09-7.35.43-8.72.92-1.21.43-2.91.91-3,2.29a4,4,0,0,0,.23,1.41c.09.29.15.67-.13.82s-.59-.07-.81-.27a21.39,21.39,0,0,1-2.19-2.74,7.71,7.71,0,0,0-1.3-1.38,16.62,16.62,0,0,1-1.44-1C105,391.82,105.21,391.23,105.23,390.58Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.23,390.58a1.22,1.22,0,0,0-1.22.87c-.31,1.09-.79,4.31-1.42,6.1-.87,2.49-1.7,7.65-1.41,9.75s5.43,3.88,8.7,5.27a43.81,43.81,0,0,1,10.45,7c3.41,2.95,10.8,6.27,15.79,6.58,5.92.36,12.69-.93,14.38-3.33,2.1-3,3.71-6.46-4.8-10.75-1.61-.81-7.22-4.35-9.13-5.63-5.16-3.44-8.75-6.53-10.85-12.15a2.34,2.34,0,0,0-2.84-2c-1.47.09-7.35.43-8.72.92-1.21.43-2.91.91-3,2.29a4,4,0,0,0,.23,1.41c.09.29.15.67-.13.82s-.59-.07-.81-.27a21.39,21.39,0,0,1-2.19-2.74,7.71,7.71,0,0,0-1.3-1.38,16.62,16.62,0,0,1-1.44-1C105,391.82,105.21,391.23,105.23,390.58Z",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.33,419.57a57.85,57.85,0,0,0-4.56-3.58h0s9.92,6.41,14.25,4.1c2.8-1.49,1.66-3.6,1.64-4.26s9.76-4.58,12.38-4.69h0c.7.42,1.29.75,1.66.94,8.51,4.29,6.9,7.79,4.8,10.75-1.69,2.4-6.64,4-14.28,3.5C131.22,426,123.74,422.52,120.33,419.57Z",
    style: {
      fill: "#BA68C8",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.33,419.57a57.85,57.85,0,0,0-4.56-3.58h0s9.92,6.41,14.25,4.1c2.8-1.49,1.66-3.6,1.64-4.26s9.76-4.58,12.38-4.69h0c.7.42,1.29.75,1.66.94,8.51,4.29,6.9,7.79,4.8,10.75-1.69,2.4-6.64,4-14.28,3.5C131.22,426,123.74,422.52,120.33,419.57Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.07,413.89c5.31,2.35,2.93,3.12,1.39,3.22s-10.38-5.41-15.7-9.82c-5.55-4.6-8.92-9.45-11-11.14-.77-.64-1.59-1.4-2.32-2.12.22-1.08.4-2.07.55-2.58a1.22,1.22,0,0,1,1.22-.87c0,.65-.19,1.24.31,1.76a16.62,16.62,0,0,0,1.44,1,7.71,7.71,0,0,1,1.3,1.38,21.39,21.39,0,0,0,2.19,2.74C114.86,403.28,125.76,411.53,131.07,413.89Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.12,416.35a.62.62,0,0,1-.34-.13.47.47,0,0,1,0-.7c1.65-1.61,9.21-5.19,13.19-4.52a.51.51,0,0,1,.45.57.53.53,0,0,1-.63.4c-3.72-.62-10.91,2.95-12.22,4.23A.57.57,0,0,1,132.12,416.35Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.55,413.36a.62.62,0,0,1-.34-.13.47.47,0,0,1,0-.7c1.66-1.61,9.22-5.19,13.2-4.52a.51.51,0,0,1,.44.58.53.53,0,0,1-.62.39c-3.72-.61-10.91,2.95-12.22,4.23A.58.58,0,0,1,127.55,413.36Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123,410.52a.61.61,0,0,1-.33-.14.46.46,0,0,1,0-.69c1.66-1.62,9.22-5.2,13.2-4.52a.5.5,0,0,1,.44.57.52.52,0,0,1-.62.4c-3.72-.62-10.92,2.95-12.23,4.22A.53.53,0,0,1,123,410.52Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.76,407.33a.53.53,0,0,1-.34-.13.47.47,0,0,1,0-.7c1.66-1.61,9.23-5.19,13.2-4.51a.49.49,0,0,1,.44.57.52.52,0,0,1-.62.39c-3.72-.61-10.92,2.95-12.23,4.23A.55.55,0,0,1,118.76,407.33Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.64,404.16a.57.57,0,0,1-.33-.13.47.47,0,0,1,0-.7c2.28-2.29,10.14-5.17,14.12-4.5a.5.5,0,0,1,.44.57.53.53,0,0,1-.62.4c-3.59-.61-11.12,2.17-13.14,4.2A.54.54,0,0,1,114.64,404.16Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.12,431.07c-.8,4.57-2,7.5-4.4,9.91s-6.44,2.67-10.39,1.29-8.92-4.26-9.68-8.42-.27-6.85,1.07-11Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.36,395.25c-1.67-.14-2.77,6-4.34,12.07-1.68,6.52-4.51,8.9-6,14.23-1.66,6.08-1.51,8.93.93,13.12s12,9.33,17.48,4.65c4.44-3.83,5.08-8.69,5.33-15,.25-6.5.36-11.08,1.18-15.92.78-4.62,1.64-9.09.25-9.82-.18.67-.37,1.52-.56,2.18-.14.51-.55,3-1.49,2.9a8,8,0,0,1,.16-1.76,1.85,1.85,0,0,0-.31-1.58,3.92,3.92,0,0,0-1.78-.91c-1.61-.49-3.23-.95-4.88-1.31-.83-.18-1.65-.33-2.49-.44a8,8,0,0,0-2.12-.08,1.37,1.37,0,0,0-1,.5,1.52,1.52,0,0,0-.15.7,3.8,3.8,0,0,1-.34,1.25c-.07.18-.26.38-.49.3a.39.39,0,0,1-.24-.41c.07-.76.25-1.29.38-2.16.06-.4.2-.94.24-1.34S47.28,395.65,47.36,395.25Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.36,395.25c-1.67-.14-2.77,6-4.34,12.07-1.68,6.52-4.51,8.9-6,14.23-1.66,6.08-1.51,8.93.93,13.12s12,9.33,17.48,4.65c4.44-3.83,5.08-8.69,5.33-15,.25-6.5.36-11.08,1.18-15.92.78-4.62,1.64-9.09.25-9.82-.18.67-.37,1.52-.56,2.18-.14.51-.55,3-1.49,2.9a8,8,0,0,1,.16-1.76,1.85,1.85,0,0,0-.31-1.58,3.92,3.92,0,0,0-1.78-.91c-1.61-.49-3.23-.95-4.88-1.31-.83-.18-1.65-.33-2.49-.44a8,8,0,0,0-2.12-.08,1.37,1.37,0,0,0-1,.5,1.52,1.52,0,0,0-.15.7,3.8,3.8,0,0,1-.34,1.25c-.07.18-.26.38-.49.3a.39.39,0,0,1-.24-.41c.07-.76.25-1.29.38-2.16.06-.4.2-.94.24-1.34S47.28,395.65,47.36,395.25Z",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.61,419.83c-.25.87-1.82,6.69.17,8.07s3.84-3,3.84-3,5.43-.49,12.89,3.26c-.49.91.39,4.27,2.57,3.9s3.67-7.07,3.69-7.16c-.26,6-1,10.72-5.3,14.43-5.44,4.68-15-.47-17.48-4.65s-2.59-7-.93-13.12C37.22,420.94,37.41,420.37,37.61,419.83Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.61,419.83c-.25.87-1.82,6.69.17,8.07s3.84-3,3.84-3,5.43-.49,12.89,3.26c-.49.91.39,4.27,2.57,3.9s3.67-7.07,3.69-7.16c-.26,6-1,10.72-5.3,14.43-5.44,4.68-15-.47-17.48-4.65s-2.59-7-.93-13.12C37.22,420.94,37.41,420.37,37.61,419.83Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.19,425.37c-.25,2.25-3,1.08-2.86-2.13S42.5,412.81,43,407.32c1.57-6.07,2.67-12.21,4.34-12.07a2.08,2.08,0,0,0,0,.23l-.53,3.13a13.34,13.34,0,0,0-.23,1.34c-.49,4.59-2.2,13.36-3.12,17.49A56.71,56.71,0,0,0,42.19,425.37Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.62,428A55.63,55.63,0,0,0,56,420.27c1-4.09,3.28-12.61,4.86-17a9,9,0,0,0,.83-2.49c.17-.61.35-1.39.52-2,0,0,0-.09.05-.13,1,.54.82,3,.35,6.14-.39,1.78-1,4-1.76,6.58-1.95,5.16-2.45,13-3.69,16S52.86,430.09,53.62,428Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.66,428.35a.58.58,0,0,1-.22-.08,25.56,25.56,0,0,0-12.7-2.9.68.68,0,0,1-.72-.45c-.07-.27.16-.5.49-.52a26.71,26.71,0,0,1,13.58,3.1.46.46,0,0,1,.2.69A.64.64,0,0,1,54.66,428.35Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.52,423.66l-.2-.07a31.37,31.37,0,0,0-14.22-3.24.69.69,0,0,1-.7-.47c0-.27.18-.5.52-.51a32.74,32.74,0,0,1,15,3.43c.3.16.4.46.23.68A.64.64,0,0,1,56.52,423.66Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43,415.75a.65.65,0,0,1-.49-.39c-.08-.27.12-.52.45-.56,7.64-.87,14.71,3.15,15,3.32a.45.45,0,0,1,.2.68.71.71,0,0,1-.85.08c-.07,0-6.94-3.93-14.05-3.11A.82.82,0,0,1,43,415.75Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.82,411.43a.66.66,0,0,1-.49-.39c-.09-.27.1-.52.43-.56a24.63,24.63,0,0,1,15.32,3.33c.28.18.35.48.15.68a.73.73,0,0,1-.87,0,23.51,23.51,0,0,0-14.27-3.09A.62.62,0,0,1,43.82,411.43Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.81,406.58a.66.66,0,0,1-.49-.39c-.09-.26.1-.51.42-.56,7.9-1.11,15.12,3.28,15.42,3.47a.45.45,0,0,1,.16.69.71.71,0,0,1-.86,0c-.07,0-7-4.29-14.37-3.25A.87.87,0,0,1,44.81,406.58Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.3,223.82C55.13,266.93,52,325.69,52,325.69c-.37,3.27-2.79,8.85-4.66,25-2,17-3.9,49-3.9,49s11.82,6.64,21.55,3.58c0,0,10.34-45.28,15.66-65.3,5-18.95,13-54.89,13-54.89L98,318.82s-.89,12.3-.68,20.92c.25,10,4,55.89,4,55.89s16.18,6.81,26.36-.7c0,0,1.32-62.91,1.81-75,1-23.62-1-69.47-1.28-100Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.3,223.82C55.13,266.93,52,325.69,52,325.69c-.37,3.27-2.79,8.85-4.66,25-2,17-3.9,49-3.9,49s11.82,6.64,21.55,3.58c0,0,10.34-45.28,15.66-65.3,5-18.95,13-54.89,13-54.89L98,318.82s-.89,12.3-.68,20.92c.25,10,4,55.89,4,55.89s16.18,6.81,26.36-.7c0,0,1.32-62.91,1.81-75,1-23.62-1-69.47-1.28-100Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.65,283l4.64-23.57s11.75-1.5,17.85-6.78c0,0-4,7.06-15.1,9.66l-4.57,20.81L98,318.82Z",
    style: {
      fill: "#BA68C8",
      opacity: 0.6000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--top--inject-13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M169,236.65a39.49,39.49,0,0,1-11.65-9.21,73.18,73.18,0,0,0-6.46-6.36c-3.79-3.48-7.73-6.79-11.63-10.16-5.64-4.87-6.56-6.73-10-15.21-1.63-4.06-11.82-28.35-11.82-28.35l-1.86-28.09c9.1-1,13.5,3.58,17.76,12.66,4.67,9.94,14,37.77,14,37.77,4.07,4.62,9.22,11.68,13.22,16.35,1.82,2.12,3.73,4.21,5.66,6.23A14.27,14.27,0,0,0,172,216c2.5.91,4.93.89,7.51,1.34,4.18.71,8.12,3.25,12.36,3.54.89.06,1.94.08,2.44.81s-.28,1.86-1.15,2.54a5.51,5.51,0,0,1-2.09,1,19.67,19.67,0,0,1-7.26.25c-.61-.06-1.43,0-1.53.62-.07.43.31.78.66,1,4,2.74,9.25,2.67,13.9,4.08.89.27,1.94.83,1.91,1.77,0,.77-.76,1.29-1.43,1.68l-5,2.92a17.22,17.22,0,0,1-3.56,1.73c-1.38.43-2.68.16-4.08.26a40.38,40.38,0,0,0-4,.85,6.06,6.06,0,0,1-2.37-.26,38.75,38.75,0,0,1-5.06-1.52A40.15,40.15,0,0,1,169,236.65Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.07,139.35a16.15,16.15,0,0,1,9.85,2.71c3,2.2,4.74,3.5,8.78,11.95s14.11,35.63,14.11,35.63L164,209.9s-2.66-.44-7.46,3.66a18.18,18.18,0,0,0-5.2,7.89s-12.86-10.39-15-12.34c-4.42-4.08-6.19-6.37-7.49-8.86-3.49-6.65-11.3-24.51-11.3-24.51Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.4,138.22c7.75.35,11.6,2,15.29,7,2.46,3.32,4.33,7.55,7.35,15.35s8.21,22.17,8.21,22.17-1.8,5-8.71,8.71c-7.08,3.85-11.14,2.7-11.14,2.7l-8.58-18Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.4,138.22c7.75.35,11.6,2,15.29,7,2.46,3.32,4.33,7.55,7.35,15.35s8.21,22.17,8.21,22.17-1.8,5-8.71,8.71c-7.08,3.85-11.14,2.7-11.14,2.7l-8.58-18Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.87,222.12a18.13,18.13,0,0,0,12.21,3.18A8.82,8.82,0,0,1,167.87,222.12Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.66,144.36s-7.67,6.12-4.37,21.55a224.73,224.73,0,0,1,4.24,30.54c.41,8.11-1,35.41-1,35.41,12,14.87,63.29,12,69.89-1.18,0,0,1.68-53.6-2.63-72-2.44-10.45-7.51-17.4-11.4-20.42l-15.88-1.79L82.71,136Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.66,144.36s-7.67,6.12-4.37,21.55a224.73,224.73,0,0,1,4.24,30.54c.41,8.11-1,35.41-1,35.41,12,14.87,63.29,12,69.89-1.18,0,0,1.68-53.6-2.63-72-2.44-10.45-7.51-17.4-11.4-20.42l-15.88-1.79L82.71,136Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.71,136l-7.29,2.65s3.87,8,7.72,12.85a46.32,46.32,0,0,0,18,13c3.16-8,4.26-13.33,3.62-19.13a34.71,34.71,0,0,0-2.16-8.44l-4.11-.47Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--head--inject-13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.42,89.7s-3.42,0-6,4.07c-1.3,2.06-2.42,5.91-.28,17.38A45.6,45.6,0,0,0,77.52,124a5.57,5.57,0,0,0,3,2.83l.49-8.63.17-6s4.28-4.95,5-9.23c1-5.51,0-7.88,0-7.88Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.22,89.89c1.24-4.78,7.86-10,19.76-9.71,9.75.28,15.16,4.09,18.07,10s.09,13.08.09,13.08l-30.35-4.5Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.93,120c3.23,2,6.62-.82,6.62-.82l-.86,19.22s1.41,3.21,6.63,6.67c7.4,4.9,21.21,3.64,14.13-7.85l.31-4.05a28.21,28.21,0,0,0,5.38.26c4-.3,6.74-3.23,8.27-7.42,2.26-6.19,3.77-16.27,2.27-27.24a9.2,9.2,0,0,0-2.83-5.57c-7.31-6.71-16.44-3-23.26-1a12.5,12.5,0,0,1-8.32-.71c2.1,2.74,3,5.29,2.11,17.54a7.64,7.64,0,0,1-1.89,2.08c-1.55,1.14-2.46-2.21-3.57-3.58a5,5,0,0,0-7.9,1.15A8.2,8.2,0,0,0,72.93,120Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,102.25l-4.52,1.54A2.51,2.51,0,0,1,93,100.68,2.34,2.34,0,0,1,96,102.25Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.57,103.84l-4.49-1.72a2.31,2.31,0,0,1,3-1.44A2.54,2.54,0,0,1,112.57,103.84Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.13,106.8a1.94,1.94,0,1,0,2-1.85A1.94,1.94,0,0,0,93.13,106.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.6,107.27a1.95,1.95,0,1,0,2-1.86A1.78,1.78,0,0,0,107.6,107.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.58,103.07l.59,12.47,6.71-1.87A29,29,0,0,0,100.58,103.07Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.34,108.08c.15,8.49,3,9.16,6,9.75,4,.77,6-1.33,13.13-1.11,4.33.13,5.65,1.46,8.08,2.54,1.79.81,3.28.63,4-1a28.25,28.25,0,0,0,1.65-9.12,68.45,68.45,0,0,1-.77,13.89c-.71,4-2.27,7.33-4.53,9.13-3.13,2.49-9.53,3.34-17.45,1.34s-10.84-5.4-11.71-8.24C79,116,80.32,111.75,79.33,110S83.34,108.08,83.34,108.08Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.47,119.23c-4.07-.2-5.42.5-5.7,3.28-.4,4-.25,5.33,1.27,5.59,1.79.3,3.11.44,3.2-.69a4.41,4.41,0,0,0-.18-2.56c-.61-.78-.38-.89,1.41-.79s1.75.4,1.2.94c-.4.39-.4,1.76-.42,2.55s.16,1.2,2.73,1c2.25-.15,1.93-2,2-5.39C107,120.88,106.08,119.47,101.47,119.23Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.6,119.74l6.6,1.11a3.28,3.28,0,0,1-3.78,2.85A3.49,3.49,0,0,1,97.6,119.74Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.44,120.77a3.1,3.1,0,0,0-.81,0,3.44,3.44,0,0,0,2.79,2.88,3,3,0,0,0,1.07,0A3.06,3.06,0,0,0,98.44,120.77Z",
    style: {
      fill: "#f28f8f"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M109.77,165.61c6.23-.34,15.5-1.54,15.5-1.54l-.61-3.7s-9.27,1.2-15.5,1.54Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "153.96 190.31 110.6 201.42 94.6 250.43 95.45 251.51 136.74 240.12 154.81 191.4 153.96 190.31",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "111.45 202.5 95.45 251.51 94.6 250.43 110.6 201.42 111.45 202.5",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "154.81 191.4 111.45 202.5 95.45 251.51 136.74 240.12 154.81 191.4",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M141.24,200.52l.49-1.65c.28-.9-2.23-.64-5.6.6l-7.8,1.63c-3.37,1.24-6.52,2.1-6.8,3l-.49,1.65Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M144.41,193.16c.17-.57-.8-.54-2.17-.3l-2.5.61s1.21-2.35-4.66-1.3c-6.46,1.15-6.87,4.28-6.87,4.28a27.85,27.85,0,0,1-3.13.84c-2.15.49-2.42.88-2.64,1.45l-.41,1,22.1-5.65S144.24,193.72,144.41,193.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.87,196.17c-2.06.73-2.93,1.09-3.35,2.5-.48,1.6-.61,2.27-.61,2.27l-11.55,3.41s.81-2.34,1-3.13-1.25-.93-3.27-.2l.64-2,17.77-4.53Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.81,200.6s.22-.74.5-1.65-2.24-.64-5.61.6l-7.79,1.63c-3.37,1.24-6.53,2.1-6.8,3l-.5,1.65Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.82,168.34c4.29-16.67,9.61-20.94,18.53-22.79C68.3,159.84,63,180.89,63,180.89l-6.94,24.32c1.65,1.45,25.71,16.45,30.11,18,1.59.56,4.62,0,6.23-.51,4.32-1.36,7.31-.86,11.46-.58L101.93,228c6.57,2.38,13.58,2.33,20.46,2.56.66,0,1.46.13,1.72.74a1.46,1.46,0,0,1-.6,1.56,6.52,6.52,0,0,0-1.35,1.16c-.52.77-.32,1.81-.47,2.73a7.2,7.2,0,0,1-2.15,3.47,16.73,16.73,0,0,1-3.47,3.1c-4.26,2.54-10.73,2.71-15.49,1.82a52.38,52.38,0,0,1-9.46-3c-2.89-1.15-20.52-6.8-22.62-7.58C53,228.67,32.34,222.23,31.25,214.78S36.06,186.82,40.82,168.34Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.59,145.07c1.33,1.39,6.57,10.7,5.72,21.69s-1,10.14-2.32,15.61-6.48,22.42-6.48,22.42l22.26,14.54s-3.34,1.25-6.07,6.08-2.5,8.87-1.17,10.13c0,0-5.34-1.53-13.37-4.33A190.63,190.63,0,0,1,36,221.45c-2.75-1.59-5.51-4.44-5.28-8.24s.76-10.11,4-22.91S42.38,158.91,46,153.05,59.59,145.07,59.59,145.07Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.36,143.74c-12,3.52-14.74,5.36-18,14.45-3.18,8.8-6.85,22.85-9.94,36.2,5.28,5.2,16.64,6.11,24.52,6.13l5.76-19.38C65.53,173.22,71.73,156.19,61.36,143.74Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.36,143.74c-12,3.52-14.74,5.36-18,14.45-3.18,8.8-6.85,22.85-9.94,36.2,5.28,5.2,16.64,6.11,24.52,6.13l5.76-19.38C65.53,173.22,71.73,156.19,61.36,143.74Z",
    style: {
      fill: "#fff"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-13"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-13"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Sit--inject-13"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "326.11 350.84 330.43 372.27 334.63 374.69 338.79 372.29 343.15 350.84 334.63 345.92 326.11 350.84",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "334.63 374.69 334.63 355.76 326.11 350.84 330.43 372.27 334.63 374.69",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "326.11 350.84 328.9 364.68 334.63 367.99 340.33 364.69 343.15 350.84 334.63 345.92 326.11 350.84",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "265.84 316.04 270.16 337.47 274.36 339.89 278.52 337.49 282.88 316.04 274.36 311.12 265.84 316.04",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "274.36 339.89 274.36 320.96 265.84 316.04 270.16 337.47 274.36 339.89",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "265.84 316.04 268.63 329.88 274.36 333.19 280.06 329.89 282.88 316.04 274.36 311.12 265.84 316.04",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "280.72 306.39 280.72 261.44 263.49 251.49 263.49 316.33 280.72 306.39",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "280.72 306.39 280.72 261.44 263.49 251.49 263.49 316.33 280.72 306.39",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "257.14 240.47 268.05 234.17 345.54 278.91 334.63 285.21 257.14 240.47",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "257.14 240.47 268.05 234.17 345.54 278.91 334.63 285.21 257.14 240.47",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "334.63 285.21 334.63 364.75 345.54 358.45 345.54 278.91 334.63 285.21",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.13,240.47V320l77.5,44.75V285.22Zm71.14,113.26-64.78-37.4V251.49l64.78,37.39Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.13,240.47V320l77.5,44.75V285.22Zm71.14,113.26-64.78-37.4V251.49l64.78,37.39Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "274.41 310.03 263.49 316.33 328.27 353.73 328.27 341.12 274.41 310.03",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "274.41 310.03 263.49 316.33 328.27 353.73 328.27 341.12 274.41 310.03",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "274.41 310.03 263.49 316.33 263.49 251.5 274.4 257.8 274.41 310.03",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "274.41 310.03 263.49 316.33 263.49 251.5 274.4 257.8 274.41 310.03",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.29,295.78l-70.12,40.48a10.12,10.12,0,0,0-4.59,7.94v14.6a10.12,10.12,0,0,0,4.59,7.95L249,408.88a10.17,10.17,0,0,0,9.18,0l70.11-40.48a10.16,10.16,0,0,0,4.59-7.95V345.86a10.18,10.18,0,0,0-4.59-7.95l-72.84-42.13A10.17,10.17,0,0,0,246.29,295.78Z",
    style: {
      fill: "#455a64"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M328.31,337.91l-72.84-42.13a10.17,10.17,0,0,0-9.18,0l-70.12,40.48c-2.54,1.46-2.54,3.83,0,5.29L249,383.7a10.17,10.17,0,0,0,9.18,0l70.11-40.49C330.84,341.75,330.84,339.38,328.31,337.91Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M171.58,358.8V344.2c0-2.92,2-4.11,4.59-2.65L249,383.7a10.15,10.15,0,0,1,4.59,7.94v14.59c0,2.93-2.06,4.11-4.59,2.65l-72.85-42.13A10.12,10.12,0,0,1,171.58,358.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.61,406.23V391.64a10.12,10.12,0,0,1,4.59-7.94l70.11-40.49c2.53-1.46,4.59-.27,4.59,2.65v14.59a10.16,10.16,0,0,1-4.59,7.95L258.2,408.88C255.66,410.34,253.61,409.16,253.61,406.23Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.29,268.6l-70.12,40.47a10.14,10.14,0,0,0-4.59,7.95v14.6a10.12,10.12,0,0,0,4.59,7.94L249,381.7a10.17,10.17,0,0,0,9.18,0l70.11-40.49a10.15,10.15,0,0,0,4.59-7.94V318.68a10.15,10.15,0,0,0-4.59-7.95L255.47,268.6A10.17,10.17,0,0,0,246.29,268.6Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.31,310.73,255.47,268.6a10.17,10.17,0,0,0-9.18,0l-70.12,40.47c-2.54,1.47-2.54,3.84,0,5.3L249,356.51a10.11,10.11,0,0,0,9.18,0L328.31,316C330.84,314.57,330.84,312.19,328.31,310.73Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.58,331.62V317c0-2.93,2-4.11,4.59-2.65L249,356.51a10.16,10.16,0,0,1,4.59,7.95v14.59c0,2.92-2.06,4.11-4.59,2.65l-72.85-42.14A10.12,10.12,0,0,1,171.58,331.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.61,379.05V364.46a10.14,10.14,0,0,1,4.59-7.95L328.31,316c2.53-1.46,4.59-.28,4.59,2.65v14.59a10.15,10.15,0,0,1-4.59,7.94L258.2,381.7C255.66,383.16,253.61,382,253.61,379.05Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.18,205.29l8,4.64a12.17,12.17,0,0,1,5.29,7.91L269.72,272a8.53,8.53,0,0,1-3.89,7.9l-70.11,40.48a10.14,10.14,0,0,1-9.18,0l-8-4.64a12.07,12.07,0,0,1-5.29-7.89L166,253.68a8.55,8.55,0,0,1,3.89-7.91L240,205.29A10.17,10.17,0,0,1,249.18,205.29Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.42,315.73l8.11,4.63c2.54,1.45,4.29.28,3.9-2.62l-7.21-54.12a12.14,12.14,0,0,0-5.29-7.91l-8-4.64c-2.53-1.46-4.28-.3-3.9,2.61l7.14,54.17A12,12,0,0,0,178.42,315.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.89,245.77,240,205.29a10.17,10.17,0,0,1,9.18,0l8,4.64c2.54,1.47,2.54,3.84,0,5.3l-70.11,40.48a10.11,10.11,0,0,1-9.18,0l-8-4.64C167.36,249.61,167.36,247.24,169.89,245.77Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.22,215.23l-70.11,40.48a8.6,8.6,0,0,0-3.89,7.91l7.21,54.12c.39,2.9,2.76,4.06,5.29,2.6l70.11-40.48a8.53,8.53,0,0,0,3.89-7.9l-7.21-54.12C262.12,214.94,259.76,213.77,257.22,215.23Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-13"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Legs--inject-13"
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "291.14 397.91 297.56 398.42 297.51 393.88 292.68 395.43 291.14 397.91"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M290.11,385.41s-1.88,3.46-2.46,4.55,2.57,6.82,3.49,8l1.54-2.48a22.32,22.32,0,0,1,.75,5.53c.17,2-.07,5.6,1.49,8.84,2.32,4.82,7.44,9.11,13.3,12.12s10,3.14,12.27,2.64,3.55-1.76,3.83-3.47S290.11,385.41,290.11,385.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.75,380.75l1-2c1.12.48-.15,3.53.23,6.91a58.92,58.92,0,0,0,3.37,14.66c3.46,8.35,7.24,14.34,8.78,18.08,2,5-6.76,7.32-16.24,2.21-4.71-2.53-12.15-9-13.23-13s-.47-9.12-1.43-12.1-4.13-7-4.15-10.1c0-1.69,1.85-4.76,3.53-7.31,1.54-2.35,3.42-6.18,4.69-5.2l-.5,1.34c.06,1.38.55,3.82,4.14,6.31C303.77,381.79,309.49,384.68,311.75,380.75Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.75,380.75l1-2c1.12.48-.15,3.53.23,6.91a58.92,58.92,0,0,0,3.37,14.66c3.46,8.35,7.24,14.34,8.78,18.08,2,5-6.76,7.32-16.24,2.21-4.71-2.53-12.15-9-13.23-13s-.47-9.12-1.43-12.1-4.13-7-4.15-10.1c0-1.69,1.85-4.76,3.53-7.31,1.54-2.35,3.42-6.18,4.69-5.2l-.5,1.34c.06,1.38.55,3.82,4.14,6.31C303.77,381.79,309.49,384.68,311.75,380.75Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.05,382.11c1.94.71,4.23,1,5.79-.28l.06,0a5.19,5.19,0,0,0-.6,4.55c.79,2.85,5.06,22.37,5.06,22.37s-4.69-16.65-5.61-19.8c-1.36-4.65-2.1-5.47-4.71-6.81Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.7,387.06a.65.65,0,0,1-.9.22.66.66,0,1,1,.9-.22Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.09,391.58a.66.66,0,0,1-.91.22.67.67,0,0,1-.22-.91.66.66,0,0,1,.91-.21A.65.65,0,0,1,307.09,391.58Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.47,396.1a.66.66,0,1,1-.22-.9A.65.65,0,0,1,308.47,396.1Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.86,400.62a.66.66,0,0,1-.91.22.66.66,0,1,1,.91-.22Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.24,405.14a.66.66,0,1,1-1.12-.68.66.66,0,1,1,1.12.68Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305,387a.26.26,0,0,1-.12-.15.25.25,0,0,1,.16-.33c.18-.07,4.34-1.49,8,.48h0a.26.26,0,0,1,.11.35.27.27,0,0,1-.36.11c-3.44-1.86-7.51-.47-7.55-.46A.28.28,0,0,1,305,387Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.4,391.46a.27.27,0,0,1,0-.48c.18-.06,4.34-1.49,8,.49h0a.26.26,0,0,1,.1.35.27.27,0,0,1-.36.11c-3.43-1.86-7.51-.47-7.55-.45A.32.32,0,0,1,306.4,391.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.78,396a.28.28,0,0,1-.12-.14.27.27,0,0,1,.16-.34c.18-.06,4.34-1.48,8,.49h0a.26.26,0,0,1-.26.46C312.11,394.6,308,396,308,396A.32.32,0,0,1,307.78,396Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.17,400.51a.24.24,0,0,1-.12-.14.26.26,0,0,1,.16-.34c.17-.06,4.33-1.48,8,.49h0a.26.26,0,0,1-.26.46c-3.43-1.85-7.51-.46-7.55-.45A.22.22,0,0,1,309.17,400.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.55,405a.33.33,0,0,1-.12-.14.27.27,0,0,1,.17-.34c.17-.06,4.33-1.48,8,.49h0a.27.27,0,0,1,.1.36.27.27,0,0,1-.36.11c-3.43-1.86-7.51-.47-7.55-.46A.25.25,0,0,1,310.55,405Z",
    style: {
      fill: "#263238"
    }
  }), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "326.68 438.76 332.41 435.3 329.63 431.51 326.49 435.73 326.68 438.76"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M318.27,428.82s.49,4.06.67,5.33,6.29,4.2,7.74,4.61l-.19-3a23.69,23.69,0,0,1,4,4.22c1.37,1.61,3.32,4.77,6.6,6.56,4.86,2.67,11.78,3.2,18.54,2.2s10.32-3.36,12-5.17,1.93-3.63,1.14-5.25S318.27,428.82,318.27,428.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.73,411.82l-.35-2.34c1.23-.26,2,3.08,4.36,5.7a61.21,61.21,0,0,0,11.69,10.35c8,5,14.77,7.73,18.33,10,4.77,3-1.29,10.26-12.38,11.67-5.5.7-15.68-.25-19-3s-5.91-7.42-8.52-9.36-7.72-3.43-9.6-6c-1-1.42-1.32-5.13-1.44-8.3-.12-2.92-.84-7.29.83-7.23l.38,1.44c.89,1.12,2.78,2.89,7.31,2.82C327.61,417.52,334.19,416.5,333.73,411.82Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.73,411.82l-.35-2.34c1.23-.26,2,3.08,4.36,5.7a61.21,61.21,0,0,0,11.69,10.35c8,5,14.77,7.73,18.33,10,4.77,3-1.29,10.26-12.38,11.67-5.5.7-15.68-.25-19-3s-5.91-7.42-8.52-9.36-7.72-3.43-9.6-6c-1-1.42-1.32-5.13-1.44-8.3-.12-2.92-.84-7.29.83-7.23l.38,1.44c.89,1.12,2.78,2.89,7.31,2.82C327.61,417.52,334.19,416.5,333.73,411.82Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.9,417c2.06-.56,4.19-1.67,4.72-3.73,0,0,0,0,0-.06a5.41,5.41,0,0,0,2.24,4.2c2.39,1.94,17.78,15.84,17.78,15.84S339.65,422,337,419.93c-4-3.12-5.08-3.36-8.09-2.91Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.43,420.8a.68.68,0,1,1-.73-.63A.68.68,0,0,1,332.43,420.8Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.33,423.78a.68.68,0,0,1-.63.73.68.68,0,1,1-.1-1.36A.69.69,0,0,1,336.33,423.78Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.23,426.76a.68.68,0,1,1-.73-.63A.69.69,0,0,1,340.23,426.76Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.13,429.74a.68.68,0,1,1-.73-.63A.7.7,0,0,1,344.13,429.74Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348,432.73a.68.68,0,0,1-1.36.1.67.67,0,0,1,.63-.73A.68.68,0,0,1,348,432.73Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.78,421.12a.28.28,0,0,1-.26-.43c.11-.16,2.77-3.87,7-4.4h0a.27.27,0,0,1,.06.54c-4,.51-6.62,4.14-6.65,4.18A.31.31,0,0,1,331.78,421.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.67,424.09a.24.24,0,0,1-.18,0,.26.26,0,0,1-.07-.38c.11-.16,2.76-3.87,7-4.4h0a.27.27,0,0,1,.06.54c-4,.51-6.62,4.14-6.65,4.18A.31.31,0,0,1,335.67,424.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.58,427.09a.32.32,0,0,1-.19,0,.28.28,0,0,1-.07-.39c.11-.15,2.77-3.86,7-4.4h0a.27.27,0,0,1,.3.24.28.28,0,0,1-.24.31c-4,.5-6.62,4.13-6.65,4.17A.28.28,0,0,1,339.58,427.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.48,430.07a.3.3,0,0,1-.19-.05.27.27,0,0,1-.07-.38c.11-.16,2.77-3.87,7-4.41h0a.28.28,0,0,1,.06.55c-4,.5-6.62,4.14-6.65,4.17A.28.28,0,0,1,343.48,430.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.38,433.05a.26.26,0,0,1-.19-.05.28.28,0,0,1-.07-.38c.11-.16,2.77-3.87,7-4.41h0a.28.28,0,0,1,.06.55c-4,.5-6.62,4.14-6.65,4.17A.28.28,0,0,1,347.38,433.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.64,377.26c1.24-7.31,3.12-18.5,4.28-26,1.84-11.92,3.07-24.33.93-29.67-2-5.06-12.59-11.61-23.71-18.3s-32.6-17.84-32.6-17.84l-56.74,9.9c1.35,10.16,1.91,15.14,7,24.2,4.95,8.76,11.87,14.33,25.4,21.33,12.14,6.28,26.53,13,29.71,14.62,4,2,7.79,3.59,9.67,9.85,1.79,6,4.2,16.41,11.77,28.86,8.65,14.27,16.37,26.95,16.37,26.95s13.83,1.49,21.25-9.41C337,411.79,330.58,395,323.64,377.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.64,377.26c.89-4.6,1.75-9.21,2.55-13.83s1.6-9.23,2.35-13.86,1.25-9.3,1.52-14c.12-2.35.18-4.7.07-7.05a22.41,22.41,0,0,0-1.28-6.9,22.09,22.09,0,0,1,.93,6.91c0,2.33-.08,4.67-.27,7-.37,4.66-1,9.3-1.67,13.93l-2.18,13.88Q324.59,370.3,323.64,377.26Z",
    style: {
      fill: "#263238"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M225.9,301.05l37,.3,3.3,6.73c-3.49,7.63-7.18,7.52-15,7.59a151.2,151.2,0,0,0-18.68,1.82s41.1,25,49,29.46,13.2,12.59,17.39,29.1c3.36,13.23,16.57,34.27,24.19,44.64a26.45,26.45,0,0,1-7.34.51s-7.72-12.68-16.37-26.95c-7.57-12.45-10-22.89-11.77-28.86-1.88-6.26-5.64-7.82-9.67-9.85-3.18-1.6-17.57-8.34-29.71-14.62-13.53-7-20.45-12.57-25.4-21.33A45.39,45.39,0,0,1,217,303.43Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M322,373.06c-6.52-16.67-13.1-33.16-14.94-36.68-3.93-7.48-37.13-28.18-38.18-28.83h0l1.53-2.24a22,22,0,0,0,3.13-8.68,23.32,23.32,0,0,1-1.37,9.83c5.11,3.32,18.09,11.74,23.29,15.33,6.54,4.51,13.5,10,16.42,17.81C314,345.41,319.38,363.88,322,373.06Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M312,415.68l3.13,5.82s16.55,2.42,22.28-9.65l-2.29-5.77C332.43,412.89,320.12,417.37,312,415.68Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--arm--inject-13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M335.47,192.46a5.49,5.49,0,0,0-2.82.41,18.11,18.11,0,0,0-2.95,1.71c-1.45,1-4.38,3.73-6.43,5.11-1.29.86-2.58,2-4.15,2.19-.53.06-1.64,0-1-.74a22.56,22.56,0,0,0,2.3-3,4.63,4.63,0,0,0,.51-3.67,1.57,1.57,0,0,0-.68-.89c-.48-.26-.75,0-1.05.3a8.79,8.79,0,0,1-1,.88c-.74.58-1.47,1.16-2.2,1.76-4.25,3.46-10.05,7.1-12.07,12.32a32.65,32.65,0,0,0-2,10c-.35,5.83-2.65,22.05-2.65,22.05s-12.07-6.07-20-10.6c-8.79-5-13.22-8.07-19.61-9.05a23.24,23.24,0,0,0-11.53,1.5l23.11,29.39s16.5,6.82,27.62,11c9.62,3.64,13.51,3.22,15.55.34,3.14-4.44,5.36-4.6,2.55-30.14-.2-1.81-.22-3.63-.32-5.45-.06-3.78-.79-6.36,2.07-8.33a84.15,84.15,0,0,0,10.63-8.42c1.49-1.38,1.83-3.18,3-4.81a7.1,7.1,0,0,0,1.52-2.53c.14-.88-.2-1.83.12-2.68.21-.58.63-1,.82-1.67.37-1.27.34-2.75,1.22-3.82.48-.59,1.26-1.1,1.2-1.86s-.65-1-1.24-1.2A4.37,4.37,0,0,0,335.47,192.46Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.24,240.87c-1.25,6.2.8,13.8.8,13.8s-4.86-7.84-3.2-15Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.52,220.4c7.6,0,10.74.82,16.24,3S299,240.55,299,240.55s.63-2.74,1.08-6.11c1.63,2.12,3.47,3.67,9.22,4.55,6.39,1,7.92-2.85,7.92-2.85s1.13,8.39,1.4,17.59c.21,7-2,14.08-12.57,12.72-1.94-.25-9.51-2.6-16.18-4.58s-21.64-7.4-21.64-7.4Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.52,220.4c7.6,0,10.74.82,16.24,3S299,240.55,299,240.55s.63-2.74,1.08-6.11c1.63,2.12,3.47,3.67,9.22,4.55,6.39,1,7.92-2.85,7.92-2.85s1.13,8.39,1.4,17.59c.21,7-2,14.08-12.57,12.72-1.94-.25-9.51-2.6-16.18-4.58s-21.64-7.4-21.64-7.4Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299,240.55c-.95,5.26-1.45,11.23,1,15.57-3.43-2.59-4.27-9-3.55-17Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.61,204.32c-.76,3.8-3.75,8.43-5.66,9.94a8.87,8.87,0,0,0,4.58-3.61C317.1,207.8,317,205.74,316.61,204.32Z",
    style: {
      fill: "#9a4a4d"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--chest--inject-13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M222.09,223.42l-16.66,9.16c-.83,4.85-.83,25.63,1.38,41.89a111,111,0,0,0,10.93,34.21s18.11,7.25,39.33-1.95c18.77-8.14,19.31-19.28,19.31-19.28l-4.28-11.27s-4.12-32.09-9.84-42.85-10.74-12.93-10.74-12.93l-12,1.08Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.09,223.42l-16.66,9.16c-.83,4.85-.83,25.63,1.38,41.89a111,111,0,0,0,10.93,34.21s18.11,7.25,39.33-1.95c18.77-8.14,19.31-19.28,19.31-19.28l-4.28-11.27s-4.12-32.09-9.84-42.85-10.74-12.93-10.74-12.93l-12,1.08Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M247.39,190.09c4.8-3.91,2.39-11.24-.18-15.75-3.28-5.59-11.18-8.29-17.7-7.48-13.74,1.71-19.62,7.2-21.4,17.1-2.32,12.9,8,23,11.09,29.73l.5-8.26c3.18-.6,5.84.13,8.77-1.29C235.59,200.68,241.75,195.58,247.39,190.09Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.92,174.92c.27,2.75,1,9.28-2.53,13.06.73,3,1.46,6.14,1.13,9.25a5.13,5.13,0,0,1-.52,1.93,2.24,2.24,0,0,1-1.53,1.19c-.89.16-1.31-.35-1.66-1a23.22,23.22,0,0,0-1.61-2.47,5.3,5.3,0,0,0-.9-.93c-1.48-1.12-5.67-2.26-7.12,2.21-1.5,4.63,2.35,9.23,5.62,10.1,4.61,1.23,5.86-1.82,5.86-1.82L220,224.7c2,4.55,14.29,13.41,24,16.47,3.07-6.82.95-15.81-2.17-18.39l-.33-6a15.33,15.33,0,0,0,7-1.48c2.68-1.29,4.67-4.25,5.24-8.83a62.27,62.27,0,0,0-2.53-25.37,21.12,21.12,0,0,0-6.68-9.93c.17,1.13-.46,4.09-5.17,5.34C233.45,178,226.4,176.28,221.92,174.92Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.5,216.74c-5.22,0-10.55-.5-13.61-1.75-2.25-.92-5.82-3.22-6.5-4.41a12.82,12.82,0,0,0,4.75,5.84c6.05,3.71,15.5,3,15.5,3Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226,192.13a.37.37,0,0,1,0-.14c0-.05.07-.07.1-.11s.31-.11.41-.14l.33-.05a5.16,5.16,0,0,1,.67-.05,7.07,7.07,0,0,1,1.3.12c.2,0,.17.49,0,.46a4.84,4.84,0,0,0-1.37,0l-.65.09-.35.08c-.11,0-.25.1-.36,0A.27.27,0,0,1,226,192.13Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.9,193.23a1.65,1.65,0,0,1,.54-.09.64.64,0,0,1,.2,0,1.35,1.35,0,0,1,.26.15c.09.05.1.29,0,.33s-.32.13-.49.18a3.38,3.38,0,0,0-.42.13l-.11,0s-.11,0,0,0a1.67,1.67,0,0,0-.23.12l-.16.1a.4.4,0,0,1-.3.07.23.23,0,0,1-.18-.21C226.89,193.62,227.53,193.34,227.9,193.23Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228,195.42a2.7,2.7,0,0,1,1.15-.88.12.12,0,0,1,.13,0,.31.31,0,0,1,.06.13.34.34,0,0,1-.11.3l-.28.16-.14.09-.06.05h0l-.05,0a2.39,2.39,0,0,0-.23.22l-.23.23a.15.15,0,0,1-.25,0A.36.36,0,0,1,228,195.42Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.5,188.84l0,0a2.12,2.12,0,0,1,.55-.39,2.72,2.72,0,0,1,.63-.27.21.21,0,0,1,.26.21.44.44,0,0,1-.19.42s-.41.21-.46.24a2.46,2.46,0,0,1-.55.14.67.67,0,0,1-.28,0s-.07,0-.08-.06a.06.06,0,0,1,0,0A.41.41,0,0,1,250.5,188.84Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.54,205.28a10.42,10.42,0,0,0,1.4-1.25,9.66,9.66,0,0,0,2.28-4.11c0-.1-.11-.34-.18-.17a14.72,14.72,0,0,1-1,2.12,10.5,10.5,0,0,1-1.46,1.86,10.74,10.74,0,0,1-1.77,1.46,18.61,18.61,0,0,1-1.69.94c-.09.06-.21.13-.21.24a4,4,0,0,0,2.2-.76l.08-.05c0,.11,0,.23,0,.34a7.16,7.16,0,0,0,.06,1.39,7,7,0,0,0,.36,1.41,6.51,6.51,0,0,0,.31.72c.08.15.18.38.34.44a2.29,2.29,0,0,0-.22-.62c-.09-.21-.18-.42-.25-.64a6.66,6.66,0,0,1-.29-1.34,6.37,6.37,0,0,1,0-1.31A3.74,3.74,0,0,1,234.54,205.28Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.64,206.93a1,1,0,0,0-.58,0,1.93,1.93,0,0,0-.85.5,2.35,2.35,0,0,0-.31.35.24.24,0,0,0-.05.16c0,.08.09,0,.13,0a1.66,1.66,0,0,1,.66-.34c.31-.08.65-.07,1-.16a.57.57,0,0,0,.22-.11c.06-.05.05-.1,0-.18A.38.38,0,0,0,241.64,206.93Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.77,190.64l1.09.16c.06,0,.14,0,.18,0a.18.18,0,0,0,0-.1.65.65,0,0,0-.21-.5c-.33-.34-1-.06-1.22.26,0,0-.07.12,0,.17a.16.16,0,0,0,.09,0Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.63,192.06a1.9,1.9,0,0,1-1.61,2.17,1.92,1.92,0,0,1-2.11-1.7,1.88,1.88,0,1,1,3.72-.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.3,186,229,188.34a2.58,2.58,0,0,1,1-3.43A2.41,2.41,0,0,1,233.3,186Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.25,203.08l5.6.66a2.78,2.78,0,0,1-3.06,2.56A3,3,0,0,1,237.25,203.08Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241,206.17a4.36,4.36,0,0,0-3.66-2.21,2.92,2.92,0,0,0,2.48,2.34A2.74,2.74,0,0,0,241,206.17Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.13,185.56l-4.65-1.3a2.32,2.32,0,0,1,2.91-1.65A2.47,2.47,0,0,1,250.13,185.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.71,190.19a1.89,1.89,0,1,1-2.13-1.71A1.92,1.92,0,0,1,249.71,190.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.43,199.7l5.88-2.78c-1-3.89-6.77-9.16-9.47-10.44Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244,241.17s-2.65-5.5-3.84-8.3c-.75-1.17-11.89-5.38-16.11-8.6-3.71-2.84-4.4-4.68-4.4-4.68l.66,5.61S227.35,240.75,244,241.17Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.16,232.87c-1.49-1.63-9.56,6.47-10.57,8.66a44.75,44.75,0,0,1-11.17-8c-4-4-4.23-5.52-4.23-5.52s1.43-3.84,2-5.6c.87-2.59,1.61-5.61,3.15-6.47l.26,3.45c1.54,2.23,4.27,4,9,6.88C235.75,230.47,239.5,231.52,240.16,232.87Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.83,222.78l-.33-6a16.32,16.32,0,0,0,1.78-.05c3.95,0,10.76,14.66,11.42,17.94-2.28-2.26-6.27-5-7.36-1.92-.87,6.49-3.34,8.46-3.34,8.46S246,230.25,241.83,222.78Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "227.87 407.56 232.19 428.99 236.38 431.41 240.55 429.01 244.9 407.56 236.38 402.64 227.87 407.56",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "236.38 431.41 236.38 412.48 227.87 407.56 232.19 428.99 236.38 431.41",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "227.87 407.56 230.66 421.4 236.38 424.71 242.09 421.41 244.9 407.56 236.38 402.64 227.87 407.56",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "167.6 372.76 171.92 394.19 176.12 396.62 180.28 394.21 184.63 372.76 176.12 367.84 167.6 372.76",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "176.12 396.62 176.12 377.68 167.6 372.76 171.92 394.19 176.12 396.62",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "167.6 372.76 170.39 386.6 176.12 389.91 181.82 386.61 184.63 372.76 176.12 367.84 167.6 372.76",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "158.89 297.19 169.81 290.89 247.3 335.63 236.39 341.93 158.89 297.19",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "158.89 297.19 169.81 290.89 247.3 335.63 236.39 341.93 158.89 297.19",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "236.39 341.93 236.39 421.47 247.3 415.17 247.3 335.63 236.39 341.93",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.89,297.19v79.53l77.49,44.75V341.94ZM230,410.45l-64.77-37.39V308.21L230,345.61Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.89,297.19v79.53l77.49,44.75V341.94ZM230,410.45l-64.77-37.39V308.21L230,345.61Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "176.17 366.75 165.25 373.06 230.03 410.45 230.03 397.84 176.17 366.75",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "176.17 366.75 165.25 373.06 230.03 410.45 230.03 397.84 176.17 366.75",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "176.17 366.75 165.24 373.05 165.24 308.22 176.15 314.52 176.17 366.75",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "176.17 366.75 165.24 373.05 165.24 308.22 176.15 314.52 176.17 366.75",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--arm--inject-13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M282.25,295.27c-3.3.38-6.54,1-9.81,1.59a48.36,48.36,0,0,1-10.12.75c-.14,0-.33-.07-.32-.21a.26.26,0,0,1,.11-.16,39.28,39.28,0,0,0,3.8-3.21,4.55,4.55,0,0,0,1.14-4.59.88.88,0,0,0-.2-.3c-.27-.24-.7-.12-1,0-1,.5-1.86,1.2-2.93,1.61a25.82,25.82,0,0,1-3.29,1.08c-1.37.34-2.79.51-4.11,1a14.86,14.86,0,0,0-4.85,3.13,8.68,8.68,0,0,1-4.13,2.39c-3.5.86-6.12.91-13.74.31a182,182,0,0,1-18.89-2.37l.76-33.11c0-16.2-3.89-27.79-8.46-30.62a24,24,0,0,0-7.34,6.44c-2.57,3.75-3.1,10.28-4.84,26-1.23,11.16-1.72,26.45-1.88,36.56-.18,11.25,4.39,14.33,14.54,14.93a177,177,0,0,0,27.29-.87h0c3.26-.3,24.16-.59,27.59-1.33a14,14,0,0,0,7.74-4.34c.5-.57,1-1.18,1.43-1.76a4.53,4.53,0,0,1,1.29-1.29c.43-.23.89-.39,1.31-.64a3.91,3.91,0,0,0,1.81-2.85c.27-1.64,2-2.15,3.35-2.67a81.1,81.1,0,0,0,8.36-3.45.31.31,0,0,0,.16-.16.43.43,0,0,0,0-.25C286.54,294.89,283.74,295.1,282.25,295.27Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.44,232c-5.3,2.93-10.14,5.73-13.4,11.13s-4.16,15.38-3.36,35.78c.69,17.46,1.38,26.84,1.67,29.75s2.82,7.36,10,8a104.22,104.22,0,0,0,14.45.05s-1.39-12.62,3.95-19.6l-5.51-1,1.1-36.39C215.58,254.79,214.88,238.46,206.44,232Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.44,232c-5.3,2.93-10.14,5.73-13.4,11.13s-4.16,15.38-3.36,35.78c.69,17.46,1.38,26.84,1.67,29.75s2.82,7.36,10,8a104.22,104.22,0,0,0,14.45.05s-1.39-12.62,3.95-19.6l-5.51-1,1.1-36.39C215.58,254.79,214.88,238.46,206.44,232Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.28,296.08c-5.45-.42-13,.52-16.19,3.52,0,0,2-5.34,16.27-6.18Z",
    style: {
      opacity: 0.15
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Symbol--inject-13"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--medical-symbol--inject-13"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "160.35 387.09 149.02 371.11 159.32 355.08 170.61 348.56 173.09 352.06 182.43 346.65 201.87 357.87 201.87 376.47 213.7 373.44 224 401.37 212.67 407.9 224 423.88 213.7 439.91 202.42 446.42 199.94 442.94 190.59 448.33 171.15 437.11 171.15 418.52 159.32 421.54 149.02 393.61 160.35 387.09",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "160.35 387.09 149.02 371.11 159.32 355.08 170.61 348.56 173.09 352.06 182.43 346.65 201.87 357.87 201.87 376.47 213.7 373.44 224 401.37 212.67 407.9 224 423.88 213.7 439.91 202.42 446.42 199.94 442.94 190.59 448.33 171.15 437.11 171.15 418.52 159.32 421.54 149.02 393.61 160.35 387.09",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "173.09 352.06 171.15 353.16 171.15 371.76 159.32 355.08 170.61 348.56 173.09 352.06",
    style: {
      fill: "#BA68C8",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "213.7 373.44 202.42 379.95 190.59 382.98 201.87 376.47 213.7 373.44",
    style: {
      fill: "#BA68C8",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "201.87 357.87 190.59 364.39 190.59 382.98 201.87 376.47 201.87 357.87",
    style: {
      fill: "#BA68C8",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "213.7 373.44 202.42 379.95 212.72 407.88 224 401.37 213.7 373.44",
    style: {
      fill: "#BA68C8",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "199.21 411.34 212.72 407.88 224 423.88 212.72 430.39 199.21 411.34",
    style: {
      fill: "#BA68C8",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "224 423.88 212.72 430.39 202.42 446.42 213.7 439.91 224 423.88",
    style: {
      fill: "#BA68C8",
      opacity: 0.65
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "190.59 448.33 199.94 442.94 190.59 429.74 190.59 448.33",
    style: {
      fill: "#BA68C8",
      opacity: 0.65
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "149.02 393.61 162.53 390.16 160.35 387.09 149.02 393.61",
    style: {
      fill: "#BA68C8",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "167.29 390.74 153 370.59 160.43 359.03 172.68 376.31 174.56 375.22 174.56 357.16 189.06 365.54 189.06 385.77 201.93 382.48 210.41 405.47 198.21 408.59 196.33 409.68 210.62 429.82 203.19 441.38 190.94 424.11 189.06 425.19 189.06 443.25 174.56 434.87 174.56 414.64 161.69 417.94 153.21 394.94 165.41 391.82 167.29 390.74",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.06,425.19l12.87,18.15,1.26-2-12.25-17.27Zm-35.85-30.25-2.09.53L159.81,419l12.87-3.29V436l16.38,9.46v-2.17l-14.5-8.38V414.64l-12.87,3.3Zm14.08-4.2L153,370.59,160.43,359l-.62-.87-8.69,13.52,14.29,20.14Zm5.39-14.43,1.88-1.09V357.16l-1.88-1.08Zm23.65,33.37L210.62,406l-.21-.55-12.2,3.12Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.06,425.19l12.87,18.15,1.26-2-12.25-17.27Zm-35.85-30.25-2.09.53L159.81,419l12.87-3.29V436l16.38,9.46v-2.17l-14.5-8.38V414.64l-12.87,3.3Zm14.08-4.2L153,370.59,160.43,359l-.62-.87-8.69,13.52,14.29,20.14Zm5.39-14.43,1.88-1.09V357.16l-1.88-1.08Zm23.65,33.37L210.62,406l-.21-.55-12.2,3.12Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "174.56 434.87 172.68 435.96 172.68 415.73 174.56 414.64 174.56 434.87",
    style: {
      fill: "#BA68C8",
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "161.69 417.94 159.81 419.02 151.13 395.47 153.21 394.94 161.69 417.94",
    style: {
      fill: "#BA68C8",
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "189.06 425.19 190.94 424.11 203.19 441.38 201.93 443.34 189.06 425.19",
    style: {
      fill: "#BA68C8",
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "153 370.59 151.13 371.68 159.81 358.16 160.43 359.03 153 370.59",
    style: {
      fill: "#BA68C8",
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "172.68 376.31 174.56 375.22 174.56 357.16 172.68 356.08 172.68 376.31",
    style: {
      fill: "#BA68C8",
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "196.33 409.68 198.21 408.59 210.41 405.47 210.62 406.02 196.33 409.68",
    style: {
      fill: "#BA68C8",
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.11,431.21l.11.11-.06,4.66Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.37,417.45l-.05,4.68,0,2.78-.06,4.69-.14-.21,0-4.4,0-2.86,0-5.22Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.59,397.55l-.08,6.68-.11,10.18c-.16-.22-.32-.45-.48-.66l-.06-6,0-3.47-.08-7.52.62.61Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183,375.11c0,1-.48,1.62-1.16,1.58l-.07,6.86,0,2.95-.08,7.31-.93-1-.07-6.46-.06-5,0-5.39a4.59,4.59,0,0,1-1.16-2.92c0-1.32.81-1.93,1.8-1.36A4.33,4.33,0,0,1,183,375.11Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.78,385.77a12.5,12.5,0,0,0-4.6-3.29l0,3.6a17.2,17.2,0,0,1,4,2.27,2.36,2.36,0,0,0,.28,1.63c.48.77,2.54,3.32,3.51,3.54S190.23,389.83,186.78,385.77Zm1.1,4a1,1,0,0,1-.41-.77c0-.3.19-.44.41-.31a1,1,0,0,1,.4.77C188.28,389.73,188.1,389.86,187.88,389.74Zm-5.83,5.14c-.15-.15-.29-.31-.43-.46-.31-.35-.62-.68-.91-1l-.44-.5c-1.27-1.51-2.2-3-2.2-4.36,0-2.06.89-2.81,2.12-2.84l0-3.85c-2.72-.49-5.07.53-5.07,4.36s2.6,6.84,5.22,9.48l.43.43.86.84.43.42c2,2,3.63,3.7,3.63,5.38,0,1.91-1.76,2-3.71,2.09l0,2.19c2.49-.06,5.35,0,5.35-3.36S184.53,397.57,182.05,394.88Zm-.23,20.77c-.14-.2-.28-.39-.43-.58s-.3-.43-.46-.64-.29-.4-.43-.61c-1.22-1.73-2.23-3.43-2.23-4.91,0-1.27.91-1.65,2.16-1.79l0-2.22c-1.88.11-3.54.57-3.54,2.91,0,2.87,1.89,5.53,3.66,7.86.14.2.29.39.43.57l.43.56.42.57c1,1.37,1.75,2.6,1.75,3.65,0,1.34-.84,1.57-1.81,1.7v1.51c1.38-.14,3-.14,3-2.84C184.69,419.7,183.31,417.69,181.82,415.65Zm-.17,15.14c-.14-.17-.29-.35-.42-.53l-.13-.17a7.48,7.48,0,0,1-.43-.66,6.38,6.38,0,0,1-1-3.34,1.54,1.54,0,0,1,.9-1.64v-1.56c-.94.2-1.73.67-1.73,2.33a8.4,8.4,0,0,0,1.8,4.83c.14.19.29.36.44.53l.11.13a6,6,0,0,0,.43.44,6.77,6.77,0,0,0,1.29,1A16.51,16.51,0,0,1,181.65,430.79Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "190.59 364.39 171.15 353.16 182.43 346.65 201.87 357.87 190.59 364.39",
    style: {
      fill: "#BA68C8",
      opacity: 0.2
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-13"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-13"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M251.65,144l-3.26-6.13,2.62-7.57V125.7l-8,4.64V135l3.46,6a.47.47,0,0,0,.23.21h0Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.65,144l-3.26-6.13,2.62-7.57V125.7l-8,4.64V135l3.46,6a.47.47,0,0,0,.23.21h0Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.82,88.86a5.3,5.3,0,0,0-2.41-4.17l-2-1.13a5.3,5.3,0,0,0-4.81,0l-30,17.38a5.32,5.32,0,0,0-2.41,4.17v33.07a5.34,5.34,0,0,0,2.41,4.17l2,1.13a5.3,5.3,0,0,0,4.81,0l9.67-5.59,3.44,6a.51.51,0,0,0,.93-.09L256,133.26l12.38-7.17a5.32,5.32,0,0,0,2.4-4.16Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.14,111.5v-3.76c0-.68-.47-.95-1.06-.61l-6.44,3.71v-7.43c0-.68-.48-1-1.07-.62l-3.25,1.88a2.36,2.36,0,0,0-1.07,1.85V114l-6.44,3.72a2.35,2.35,0,0,0-1.06,1.85v3.75c0,.68.47,1,1.06.62l6.44-3.72v7.43c0,.69.48,1,1.07.62l3.25-1.88a2.35,2.35,0,0,0,1.07-1.84v-7.44l6.44-3.72A2.33,2.33,0,0,0,263.14,111.5Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.18,138.18a5.34,5.34,0,0,0,2.41,4.17l2,1.13a5.39,5.39,0,0,0,4.4.19c-1.13.43-2-.21-2-1.58V109a4.85,4.85,0,0,1,.71-2.37l-6.78-3.91a4.94,4.94,0,0,0-.7,2.37Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.74,88.17c-.28-1-1.21-1.35-2.32-.71l-30.06,17.39a4.77,4.77,0,0,0-1.7,1.8l-6.77-3.91a4.92,4.92,0,0,1,1.7-1.8l30-17.38a5.3,5.3,0,0,1,4.81,0l2,1.13A5.29,5.29,0,0,1,270.74,88.17Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealthI);
export default __webpack_public_path__ + "static/media/healthI.c70587ecdf458ac46e9783569c3bedf0.svg";
export { ForwardRef as ReactComponent };